
// --------------------Based on user cotact data-----------------//

// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import axios from 'axios';
// import { FaPaperPlane, FaClipboardCheck, FaEye, FaTh, FaIdBadge, FaUserCircle, FaClipboardList, FaEnvelope, FaCalendarAlt, FaPhoneAlt, FaUser, FaRegSmileBeam, FaRegClock } from 'react-icons/fa';
// import { MdSend, MdCheckCircle } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';

// const Dashboard = () => {
//   const [apiData, setApiData] = useState(null);

//   // useEffect(() => {
//   //   const user = JSON.parse(sessionStorage.getItem('user'));
//   //   if (!user || !user.email) return;

//   //   axios.get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(user.email)}`)
//   //     .then((response) => {
//   //       const userData = response.data;
//   //       if (userData.wa_id) {
//   //         setWaId(userData.wa_id); // ✅ Set waId here

//   //         // Get QR Rating
//   //         fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//   //           .then(res => res.json())
//   //           .then(data => {
//   //             if (data?.data?.length > 0) {
//   //               const { display_phone_number, verified_name, quality_rating, code_verification_status } = data.data[0];
//   //               setApiData({
//   //                 phoneNumber: display_phone_number,
//   //                 displayName: verified_name,
//   //                 qualityRating: quality_rating,
//   //                 codeverificationstatus: code_verification_status
//   //               });
//   //             }
//   //           });
//   //       }
//   //     })
//   //     .catch((err) => {
//   //       console.error('Error retrieving user or qratting data:', err);
//   //     });
//   // }, []);


//   useEffect(() => {
//   const loggedUser = JSON.parse(sessionStorage.getItem("user"));

//   if (!loggedUser) return;

//   // ROLE-BASED EMAIL
//   const emailToUse =
//     loggedUser.role === "admin"
//       ? loggedUser.email   // Admin → use own email
//       : loggedUser.adminEmail; // Member → use adminEmail

//   console.log("API Email Used:", emailToUse);

//   if (!emailToUse) return;

//   axios
//     .get(
//       `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//         emailToUse
//       )}`
//     )
//     .then((response) => {
//       const userData = response.data;
//       console.log('this is userData1',userData)
//       if (userData.wa_id) {
//         setWaId(userData.wa_id);

//         fetch(
//           `https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`
//         )
//           .then((res) => res.json())
//           .then((data) => {
//             if (data?.data?.length > 0) {
//               const {
//                 display_phone_number,
//                 verified_name,
//                 quality_rating,
//                 code_verification_status,
//               } = data.data[0];

//               setApiData({
//                 phoneNumber: display_phone_number,
//                 displayName: verified_name,
//                 qualityRating: quality_rating,
//                 codeverificationstatus: code_verification_status,
//               });
//             }
//           });
//       }
//     })
//     .catch((err) => {
//       console.error("Error retrieving user data:", err);
//     });

// }, []);



//   const [contactsCount, setContactsCount] = useState(0);
//   // useEffect(() => {
//   //   const user = JSON.parse(sessionStorage.getItem('user'));
//   //   console.log("User from sessionStorage:", user);
//   //   if (!user || !user.id) return;
//   //   axios.get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${user.id}`)
//   //     .then(response => {
//   //       const contacts = response.data.contacts || [];
//   //       console.log('Fetched contacts:', contacts);
//   //       setContactsCount(contacts.length);
//   //     })
//   //     .catch(error => {
//   //       console.error('Failed to fetch contacts:', error);
//   //     });
//   // }, []);

//   useEffect(() => {
//   const user = JSON.parse(sessionStorage.getItem('user'));
//   console.log("User from sessionStorage:", user);

//   if (!user) return;

//   // ------------------------------------------
//   // CONDITION:
//   // Admin => use user.id
//   // Member => use user.userId
//   // ------------------------------------------
//   const finalUserId =
//     user.role === "admin"
//       ? user.id
//       : user.role === "member"
//       ? user.userId
//       : null;

//   console.log("Final user ID to use:", finalUserId);

//   if (!finalUserId) return;

//   axios
//     .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//     .then((response) => {
//       const contacts = response.data.contacts || [];
//       console.log("Fetched contacts:", contacts);
//       setContactsCount(contacts.length);
//     })
//     .catch((error) => {
//       console.error("Failed to fetch contacts:", error);
//     });
// }, []);


//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         } else {
//           console.warn("Unexpected template data format", data);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });

//   }, [waId]);


//   // webhookData
//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table; // e.g., "prk_webhook" or "rv_webhook"
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );
//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);


//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;


//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'receivedMessage') {
//       filtered = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType || filterType === '');
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const pageNumbers = [];
//   for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
//     pageNumbers.push(i);
//   }

//   const [searchTerm, setSearchTerm] = useState('');
//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const filtered = webhookData.filter(item =>
//       item.waid?.includes(value) || item.customer_mobile?.includes(value)
//     );
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };


//   return (
//     <div className="container mt-4 dashboard" style={{fontSize:'12px'}}>
//       <div className="card mb-4 p-3" style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//         <div className="row text-center">
//           <div className="col"><strong><FaPhoneAlt style={{ marginRight: '5px' }} /> Phone Number:</strong><br />{apiData?.phoneNumber || ''}</div>
//           <div className="col"><strong><FaUser style={{ marginRight: '5px' }} /> Display Name:</strong><br />{apiData?.displayName || ''}</div>
//           <div className="col"><strong><FaRegSmileBeam style={{ marginRight: '5px' }} /> Quality Rating:</strong><br /><span className={apiData?.qualityRating === 'GREEN' ? "text-success" : "text-warning"}>  ● {apiData?.qualityRating === 'GREEN' ? 'High' : 'Low'}</span></div>
//           <div className="col"><strong><FaRegClock style={{ marginRight: '5px' }} /> Status:</strong><br />{apiData?.codeverificationstatus || ''}</div>
//         </div>
//       </div>

//       <div className="">
//         <div className="card p-3" style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//           <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}><FaEnvelope style={{ marginRight: '5px' }} />Messaging</h5>
//           <div className="row text-center">
//             <div className="col"><MdSend style={{ marginRight: '8px' }} /><strong>Messages Sent:</strong> {sentMessagesCount}</div>
//             <div className="col"><MdCheckCircle style={{ marginRight: '8px' }} /><strong>Messages Delivered:</strong> {deliveredMessagesCount}</div></div>
//         </div>
//       </div>

//       <>
//         <div>
//           <div>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('sent')}><FaPaperPlane style={{ marginRight: '5px' }} /> Sent</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('delivered')}><FaClipboardCheck style={{ marginRight: '5px' }} /> Delivered</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('read')}><FaEye style={{ marginRight: '5px' }} /> Read</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('receivedMessage')}> <FaEnvelope style={{ marginRight: '5px' }} />Received Message</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('')}><FaTh style={{ marginRight: '5px' }} /> All</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('/send-messaging')} ><FaPaperPlane style={{ marginRight: '5px' }} /> Send</button>
//             <input type="text" placeholder="Search by Mobile Number" value={searchTerm} onChange={handleSearch} style={{ padding: '5px', width: '500px', borderRadius: '4px', border: '1px solid #ccc' }} />
//           </div>

//           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead>
//               <tr>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaIdBadge style={{ marginRight: '5px' }} /> ID</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaUserCircle style={{ marginRight: '5px' }} /> Customer Mobile</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaClipboardList style={{ marginRight: '5px' }} /> Status</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaEnvelope style={{ marginRight: '5px' }} /> Received Message</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaCalendarAlt style={{ marginRight: '5px' }} /> Received Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((item) => (
//                 <tr key={item.id}>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.id}</td>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.waid ? (<span style={{ color: 'green', cursor: 'pointer' }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                   ) : (
//                     <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                   )}
//                   </td><td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.status}</td>
//                   <td onClick={() => handleMessageClick(item.receivedMessage)} style={{ cursor: 'pointer', color: 'blue', border: '1px solid #ddd', padding: '8px' }}>{item.receivedMessage} </td>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{new Date(item.received_date).toLocaleDateString()}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <div style={{ marginTop: '20px', textAlign: 'center' }}>
//             <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ padding: '5px 10px', margin: '5px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>Previous</button>
//             <span style={{ padding: '5px 10px', margin: '5px', fontWeight: 'bold' }}>{currentPage}</span>
//             <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers.length} style={{ padding: '5px 10px', margin: '5px', cursor: currentPage === pageNumbers.length ? 'not-allowed' : 'pointer' }}>Next</button>
//           </div>
//         </div>
//       </>

//       <div className="container mb-4">
//         <div className="card p-3" style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//           <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>
//             <i className="fas fa-chart-line me-2"></i>eMedha Chatbot Services Plan: Startup</h5>
//           <div className="row text-center">
//             <div className="col"><strong>Message Templates:</strong> {templateCount} / {loggedInUser?.email === "vckumar555@gmail.com" ? 100 : 250}</div>
//             <div className="col"><strong>Contacts:</strong> {contactsCount} / {loggedInUser?.email === "vckumar555@gmail.com" ? '50,000' : '20,000'}</div>
//             <div className="col"><strong>Messages Sent:</strong> {sentMessagesCount.toLocaleString()} / {loggedInUser?.email === "vckumar555@gmail.com" ? '25,000' : '50,000'}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


// import React, { useState } from "react";
// import {
//   Phone, BadgeCheck, Star, Activity, Send, CheckCheck, Inbox, Eye, MailOpen, ArrowRight,
// } from "lucide-react";

// // Mocking external imports for a self-contained execution environment
// const MESSAGE_DATA = [
//   { id: "MSG-1001", mobile: "+91 98765 43210", status: "sent", message: "Hello, your order is confirmed!", date: "2026-06-26 10:30 AM" },
//   { id: "MSG-1002", mobile: "+91 87654 32109", status: "delivered", message: "Welcome to our platform.", date: "2026-06-26 11:15 AM" },
//   { id: "MSG-1003", mobile: "+91 76543 21098", status: "read", message: "Flash Sale ending tonight!", date: "2026-06-26 12:00 PM" },
//   { id: "MSG-1004", mobile: "+91 65432 10987", status: "received", message: "Hi, I need support with billing.", date: "2026-06-26 01:45 PM" },
// ];

// const STATUS_BADGE = {
//   sent: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
//   delivered: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" },
//   read: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" },
//   received: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" },
// };

// // Base Theme variables fallback
// const THEME = {
//   background: "#ffffff",
//   foreground: "#0f172a",
//   muted: "#f1f5f9",
//   mutedForeground: "#64748b",
//   border: "#e2e8f0",
//   primary: "#6366f1",
//   primaryForeground: "#ffffff",
//   card: "#ffffff",
// };

// // --- Component: ProgressBar ---
// function ProgressBar({ label, current, max }) {
//   const pct = Math.round((current / max) * 100);
//   return (
//     <div style={{ marginBottom: "16px" }}>
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "between", marginBottom: "6px" }}>
//         <span style={{ fontSize: "12px", fontWeight: 500, color: THEME.foreground, marginRight: "auto" }}>{label}</span>
//         <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{current.toLocaleString()} / {max.toLocaleString()}</span>
//       </div>
//       <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
//         <div 
//           style={{ 
//             height: "100%", 
//             backgroundColor: THEME.primary, 
//             borderRadius: "9999px", 
//             transition: "all 0.3s ease", 
//             width: `${pct}%` 
//           }} 
//         />
//       </div>
//       <p style={{ fontSize: "10px", color: THEME.mutedForeground, marginTop: "4px", margin: "4px 0 0 0" }}>{pct}% used</p>
//     </div>
//   );
// }

// // --- Component: Hoverable Button ---
// function HoverButton({ onClick, children, baseStyle, hoverStyle }) {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <button
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       style={{
//         ...baseStyle,
//         ...(isHovered ? hoverStyle : {}),
//       }}
//     >
//       {typeof children === "function" ? children(isHovered) : children}
//     </button>
//   );
// }

// // --- Main Dashboard Component ---
// export default function Dashboard({ navigate = (s) => console.log("Navigating to:", s) }) {

//   const TABS = [
//     { label: "Sent", status: "Sent Messages", icon: <Send size={13} />, color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" } },
//     { label: "Delivered", status: "Delivered Messages", icon: <CheckCheck size={13} />, color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } },
//     { label: "Read", status: "Read Messages", icon: <Eye size={13} />, color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } },
//     { label: "Received Message", status: "Received Messages", icon: <MailOpen size={13} />, color: { color: "#7c3aed", backgroundColor: "#f5f3ff", borderColor: "#ddd6fe" }, badge: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" } },
//   ];

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, padding: "24px", fontFamily: "system-ui, sans-serif" }}>

//       {/* Header section */}
//       <div style={{ paddingBottom: "20px" }}>
//         <h1 style={{ fontSize: "20px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Dashboard</h1>
//         <p style={{ fontSize: "14px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Overview of your chatbot activity</p>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

//         {/* Meta Stats Row */}
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//           {[
//             { icon: <Phone size={15} />, label: "Phone Number", value: "+91 89191 71985", color: { color: "#4f46e5", backgroundColor: "#e0e7ff" } },
//             { icon: <BadgeCheck size={15} />, label: "Display Name", value: "Emedha", color: { color: "#0284c7", backgroundColor: "#e0f2fe" } },
//             { icon: <Star size={15} />, label: "Quality Rating", value: <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}><span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#10b981" }} />High</span>, color: { color: "#059669", backgroundColor: "#ecfdf5" } },
//             { icon: <Activity size={15} />, label: "Status", value: <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "12px", fontWeight: 600, backgroundColor: "#fee2e2", color: "#b91c1c", border: "1px solid #fecaca" }}>EXPIRED</span>, color: { color: "#dc2626", backgroundColor: "#fee2e2" } },
//           ].map(({ icon, label, value, color }) => (
//             <div key={label} style={{ flex: "1 1 200px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//               <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", ...color }}>{icon}</span>
//               <p style={{ fontSize: "11px", color: THEME.mutedForeground, fontWeight: "500", uppercase: "true", letterSpacing: "0.05em", margin: "0 0 2px 0" }}>{label.toUpperCase()}</p>
//               <p style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{value}</p>
//             </div>
//           ))}
//         </div>

//         {/* Analytics Row */}
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
//           {/* Messaging Card */}
//           <div style={{ flex: "2 1 350px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
//               <Send size={15} style={{ color: THEME.primary }} />
//               <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Messaging</h3>
//             </div>
//             <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//               <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                 <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Send size={16} style={{ color: THEME.primary }} /></div>
//                 <div>
//                   <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES SENT</p>
//                   <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>3,752</p>
//                 </div>
//               </div>
//               <div style={{ height: "1px", backgroundColor: THEME.border }} />
//               <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                 <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#ecfdf5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><CheckCheck size={16} style={{ color: "#059669" }} /></div>
//                 <div>
//                   <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES DELIVERED</p>
//                   <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>4,053</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Usage Card */}
//           <div style={{ flex: "3 1 450px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <Activity size={15} style={{ color: THEME.primary }} />
//                 <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Usage</h3>
//               </div>
//               <span style={{ fontSize: "12px", padding: "2px 8px", backgroundColor: THEME.muted, color: THEME.foreground, borderRadius: "9999px", fontWeight: "500" }}>Startup Plan</span>
//             </div>
//             <div>
//               <ProgressBar label="Message Templates" current={25} max={250} />
//               <ProgressBar label="Contacts" current={321} max={20000} />
//               <ProgressBar label="Messages Sent" current={3752} max={50000} />
//             </div>
//           </div>
//         </div>

//         {/* Navigation Action Cards */}
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//           {/* Main Action Callout */}
//           <HoverButton
//             onClick={() => navigate("Send Message")}
//             baseStyle={{
//               flex: "1 1 180px", backgroundColor: THEME.primary, borderRadius: "12px", border: `1px solid ${THEME.primary}`,
//               padding: "16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease-in-out", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//             }}
//             hoverStyle={{ transform: "translateY(-2px)", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
//           >
//             {(hovered) => (
//               <>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
//                   <span style={{ width: "32px", height: "32px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.2)", color: "#ffffff", border: "1px solid rgba(255,255,255,0.2)" }}>
//                     <Send size={13} />
//                   </span>
//                   <ArrowRight size={13} style={{ color: "rgba(255,255,255,0.6)", transform: hovered ? "translateX(2px)" : "none", transition: "all 0.2s" }} />
//                 </div>
//                 <p style={{ fontSize: "12px", fontWeight: "600", color: "#ffffff", margin: 0 }}>Send Message</p>
//                 <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.7)", marginTop: "2px", marginBottom: 0 }}>Click to compose</p>
//                 <span style={{ display: "inline-flex", alignItems: "center", marginTop: "8px", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500", backgroundColor: "rgba(255,255,255,0.2)", color: "#ffffff", border: "1px solid rgba(255,255,255,0.2)" }}>
//                   New message
//                 </span>
//               </>
//             )}
//           </HoverButton>

//           {/* Dynamic Filter Cards */}
//           {TABS.map(({ label, status, icon, color, badge }) => {
//             const count = MESSAGE_DATA.filter((r) => r.status === label.toLowerCase().replace(" message", "")).length;
//             return (
//               <HoverButton
//                 key={label}
//                 onClick={() => navigate(status)}
//                 baseStyle={{
//                   flex: "1 1 180px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`,
//                   padding: "16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease-in-out", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)", borderColor: "rgba(99,102,241,0.2)", boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)" }}
//               >
//                 {(hovered) => (
//                   <>
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
//                       <span style={{ width: "32px", height: "32px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid", ...color }}>{icon}</span>
//                       <ArrowRight size={13} style={{ color: THEME.mutedForeground, transform: hovered ? "translateX(2px)" : "none", transition: "all 0.2s" }} />
//                     </div>
//                     <p style={{ fontSize: "12px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{label}</p>
//                     <p style={{ fontSize: "11px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Click to view all</p>
//                     <span style={{ display: "inline-flex", alignItems: "center", marginTop: "8px", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500", border: "1px solid", ...badge }}>
//                       {count} messages
//                     </span>
//                   </>
//                 )}
//               </HoverButton>
//             );
//           })}
//         </div>

//         {/* Data Container Block */}
//         <div style={{ backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>
//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//               <Inbox size={15} style={{ color: THEME.primary }} />
//               <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>All Messages</h3>
//             </div>
//             <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{MESSAGE_DATA.length} total</span>
//           </div>

//           {/* Table Container - handles responsiveness cleanly with native overflow */}
//           <div style={{ overflowX: "auto", width: "100%" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "14px" }}>
//               <thead>
//                 <tr style={{ borderBottom: `1px solid ${THEME.border}`, backgroundColor: "rgba(241,245,249,0.4)" }}>
//                   {["ID", "Customer Mobile", "Status", "Message", "Date"].map((h) => (
//                     <th key={h} style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase", letterSpacing: "0.05em" }}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {MESSAGE_DATA.map((row) => (
//                   <tr key={row.id} style={{ borderBottom: `1px solid ${THEME.border}`, transition: "background-color 0.2s" }}>
//                     <td style={{ padding: "14px 20px" }}><span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{row.id}</span></td>
//                     <td style={{ padding: "14px 20px", fontSize: "12px", fontWeight: "500", color: THEME.foreground }}>{row.mobile}</td>
//                     <td style={{ padding: "14px 20px" }}>
//                       <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500", textTransform: "capitalize", border: "1px solid", ...STATUS_BADGE[row.status] }}>
//                         {row.status}
//                       </span>
//                     </td>
//                     <td style={{ padding: "14px 20px", maxWidth: "280px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                       {row.message ? <span style={{ fontSize: "12px", color: THEME.foreground }}>{row.message}</span> : <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>—</span>}
//                     </td>
//                     <td style={{ padding: "14px 20px", fontSize: "12px", color: THEME.mutedForeground, whiteSpace: "nowrap" }}>{row.date}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Table Footer / Pagination */}
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: `1px solid ${THEME.border}` }}>
//             <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>Showing {MESSAGE_DATA.length} of {MESSAGE_DATA.length} entries</p>
//             <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//               <button style={{ padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: THEME.mutedForeground, border: `1px solid ${THEME.border}`, backgroundColor: "transparent", cursor: "pointer" }}>Previous</button>
//               <button style={{ padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", backgroundColor: THEME.primary, color: THEME.primaryForeground, border: "none", cursor: "pointer" }}>1</button>
//               <button style={{ padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: THEME.mutedForeground, border: `1px solid ${THEME.border}`, backgroundColor: "transparent", cursor: "pointer" }}>Next</button>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Phone, BadgeCheck, Star, Activity, Send, CheckCheck, Inbox, Eye, MailOpen, ArrowRight, Search
// } from "lucide-react";

// // --- Theme Definition ---
// const THEME = {
//   background: "#f8fafc",
//   foreground: "#0f172a",
//   muted: "#f1f5f9",
//   mutedForeground: "#64748b",
//   border: "#e2e8f0",
//   primary: "#6366f1",
//   primaryForeground: "#ffffff",
//   card: "#ffffff",
// };

// const STATUS_BADGE = {
//   sent: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
//   delivered: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" },
//   read: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" },
//   received: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" },
// };

// // --- Sub-component: ProgressBar ---
// function ProgressBar({ label, current, max }) {
//   const numericCurrent = Number(current) || 0;
//   const numericMax = typeof max === 'string' ? Number(max.replace(/,/g, '')) : Number(max) || 1;
//   const pct = Math.min(Math.round((numericCurrent / numericMax) * 100), 100);

//   return (
//     <div style={{ marginBottom: "16px" }}>
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
//         <span style={{ fontSize: "12px", fontWeight: 500, color: THEME.foreground }}>{label}</span>
//         <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{numericCurrent.toLocaleString()} / {max.toLocaleString()}</span>
//       </div>
//       <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
//         <div 
//           style={{ 
//             height: "100%", 
//             backgroundColor: THEME.primary, 
//             borderRadius: "9999px", 
//             transition: "all 0.3s ease", 
//             width: `${pct}%` 
//           }} 
//         />
//       </div>
//       <p style={{ fontSize: "10px", color: THEME.mutedForeground, marginTop: "4px", margin: "4px 0 0 0" }}>{pct}% used</p>
//     </div>
//   );
// }

// // --- Sub-component: HoverButton ---
// function HoverButton({ onClick, children, baseStyle, hoverStyle }) {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <button
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       style={{ ...baseStyle, ...(isHovered ? hoverStyle : {}) }}
//     >
//       {typeof children === "function" ? children(isHovered) : children}
//     </button>
//   );
// }

// const Dashboard = () => {
//   // --- All original state hooks ---
//   const [apiData, setApiData] = useState(null);
//   const [contactsCount, setContactsCount] = useState(0);
//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');

//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));

//   // --- Original Hook 1: Fetch user metadata ---
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
//     console.log("API Email Used:", emailToUse);
//     if (!emailToUse) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//       .then((response) => {
//         const userData = response.data;
//         console.log('this is userData1', userData);
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);

//           fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//             .then((res) => res.json())
//             .then((data) => {
//               if (data?.data?.length > 0) {
//                 const {
//                   display_phone_number, verified_name, quality_rating, code_verification_status,
//                 } = data.data[0];

//                 setApiData({
//                   phoneNumber: display_phone_number,
//                   displayName: verified_name,
//                   qualityRating: quality_rating,
//                   codeverificationstatus: code_verification_status,
//                 });
//               }
//             });
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // --- Original Hook 2: Contacts Count ---
//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     console.log("User from sessionStorage:", user);
//     if (!user) return;

//     const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
//     console.log("Final user ID to use:", finalUserId);
//     if (!finalUserId) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//       .then((response) => {
//         const contacts = response.data.contacts || [];
//         console.log("Fetched contacts:", contacts);
//         setContactsCount(contacts.length);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch contacts:", error);
//       });
//   }, []);

//   // --- Original Hook 3: Template Status Counts ---
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         } else {
//           console.warn("Unexpected template data format", data);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });
//   }, [waId]);

//   // --- Original Hook 4: Webhook table fetch ---
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table;
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );
//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);

//   // --- Original Count Computations ---
//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;
//   const readMessagesCount = webhookData.filter(item => item.status === 'read').length;
//   const receivedMessagesCount = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '').length;

//   // --- Original Helper Handlers ---
//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'receivedMessage') {
//       filtered = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType || filterType === '');
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const filtered = webhookData.filter(item =>
//       item.waid?.includes(value) || item.customer_mobile?.includes(value)
//     );
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   // --- Pagination Slice Calculations ---
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

//   // --- Navigation Tab Configuration mappings ---
//   const TABS = [
//     { label: "Sent", statusFilter: "sent", icon: <Send size={13} />, count: sentMessagesCount, color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" } },
//     { label: "Delivered", statusFilter: "delivered", icon: <CheckCheck size={13} />, count: deliveredMessagesCount, color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } },
//     { label: "Read", statusFilter: "read", icon: <Eye size={13} />, count: readMessagesCount, color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } },
//     { label: "Received Message", statusFilter: "receivedMessage", icon: <MailOpen size={13} />, count: receivedMessagesCount, color: { color: "#7c3aed", backgroundColor: "#f5f3ff", borderColor: "#ddd6fe" }, badge: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" } },
//   ];

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif" }}>

//       {/* Header section */}
//       <div style={{ paddingBottom: "20px" }}>
//         <h1 style={{ fontSize: "22px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Dashboard</h1>
//         <p style={{ fontSize: "14px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Overview of your chatbot activity</p>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

//         {/* Meta Stats Row */}
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//           {[
//             { icon: <Phone size={15} />, label: "Phone Number", value: apiData?.phoneNumber || '—', color: { color: "#4f46e5", backgroundColor: "#e0e7ff" } },
//             { icon: <BadgeCheck size={15} />, label: "Display Name", value: apiData?.displayName || '—', color: { color: "#0284c7", backgroundColor: "#e0f2fe" } },
//             { 
//               icon: <Star size={15} />, 
//               label: "Quality Rating", 
//               value: (
//                 <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
//                   <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: apiData?.qualityRating === 'GREEN' ? "#10b981" : "#f59e0b" }} />
//                   {apiData?.qualityRating === 'GREEN' ? 'High' : apiData?.qualityRating ? 'Low' : '—'}
//                 </span>
//               ), 
//               color: apiData?.qualityRating === 'GREEN' ? { color: "#059669", backgroundColor: "#ecfdf5" } : { color: "#d97706", backgroundColor: "#fef3c7" }
//             },
//             { icon: <Activity size={15} />, label: "Status", value: apiData?.codeverificationstatus ? String(apiData.codeverificationstatus).toUpperCase() : '—', color: { color: "#dc2626", backgroundColor: "#fee2e2" } },
//           ].map(({ icon, label, value, color }) => (
//             <div key={label} style={{ flex: "1 1 220px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//               <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", ...color }}>{icon}</span>
//               <p style={{ fontSize: "11px", color: THEME.mutedForeground, fontWeight: "500", letterSpacing: "0.05em", margin: "0 0 2px 0" }}>{label.toUpperCase()}</p>
//               <p style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{value}</p>
//             </div>
//           ))}
//         </div>

//         {/* Analytics Row */}
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
//           {/* Messaging Card */}
//           <div style={{ flex: "2 1 350px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
//               <Send size={15} style={{ color: THEME.primary }} />
//               <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Messaging Overview</h3>
//             </div>
//             <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//               <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                 <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Send size={16} style={{ color: THEME.primary }} /></div>
//                 <div>
//                   <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES SENT</p>
//                   <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>{sentMessagesCount.toLocaleString()}</p>
//                 </div>
//               </div>
//               <div style={{ height: "1px", backgroundColor: THEME.border }} />
//               <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                 <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#ecfdf5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><CheckCheck size={16} style={{ color: "#059669" }} /></div>
//                 <div>
//                   <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES DELIVERED</p>
//                   <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>{deliveredMessagesCount.toLocaleString()}</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Usage Service Plans Card */}
//           <div style={{ flex: "3 1 450px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <Activity size={15} style={{ color: THEME.primary }} />
//                 <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Plan Resource Usage</h3>
//               </div>
//               <span style={{ fontSize: "12px", padding: "2px 8px", backgroundColor: THEME.muted, color: THEME.foreground, borderRadius: "9999px", fontWeight: "500" }}>Startup Plan</span>
//             </div>
//             <div>
//               <ProgressBar 
//                 label="Message Templates" 
//                 current={templateCount} 
//                 max={loggedInUser?.email === "vckumar555@gmail.com" ? 100 : 250} 
//               />
//               <ProgressBar 
//                 label="Contacts" 
//                 current={contactsCount} 
//                 max={loggedInUser?.email === "vckumar555@gmail.com" ? 50000 : 20000} 
//               />
//               <ProgressBar 
//                 label="Messages Sent" 
//                 current={sentMessagesCount} 
//                 max={loggedInUser?.email === "vckumar555@gmail.com" ? 25000 : 50000} 
//               />
//             </div>
//           </div>
//         </div>

//         {/* Filter Navigation Options Bar */}
//         <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
//           {/* Send Messaging Action trigger */}
//           <HoverButton
//             onClick={() => navigate('/send-messaging')}
//             baseStyle={{
//               flex: "1 1 150px", backgroundColor: THEME.primary, borderRadius: "12px", border: `1px solid ${THEME.primary}`,
//               padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease-in-out", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//             }}
//             hoverStyle={{ transform: "translateY(-2px)", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
//           >
//             {(hovered) => (
//               <>
//                 <div style={{ display: "flex", alignItems: "center", justifyBetween: "space-between", marginBottom: "8px", width: "100%" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.2)", color: "#ffffff" }}>
//                     <Send size={13} />
//                   </span>
//                   <ArrowRight size={13} style={{ color: "rgba(255,255,255,0.6)", marginLeft: "auto", transform: hovered ? "translateX(2px)" : "none", transition: "all 0.2s" }} />
//                 </div>
//                 <p style={{ fontSize: "13px", fontWeight: "600", color: "#ffffff", margin: 0 }}>Compose</p>
//                 <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.7)", marginTop: "1px", margin: 0 }}>Send Messaging</p>
//               </>
//             )}
//           </HoverButton>

//           {/* All Data Clear Filter Reset */}
//           <HoverButton
//             onClick={() => filterData('')}
//             baseStyle={{
//               flex: "1 1 140px", backgroundColor: status === '' ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === '' ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//               padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease"
//             }}
//             hoverStyle={{ transform: "translateY(-2px)" }}
//           >
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//               <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f1f5f9", color: THEME.foreground }}>
//                 <Inbox size={13} />
//               </span>
//             </div>
//             <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>All</p>
//             <p style={{ fontSize: "11px", color: THEME.mutedForeground, marginTop: "1px", margin: 0 }}>{webhookData.length} total logs</p>
//           </HoverButton>

//           {/* Map Filters */}
//           {TABS.map(({ label, statusFilter, icon, count, color, badge }) => (
//             <HoverButton
//               key={label}
//               onClick={() => filterData(statusFilter)}
//               baseStyle={{
//                 flex: "1 1 160px", backgroundColor: status === statusFilter ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === statusFilter ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                 padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//               }}
//               hoverStyle={{ transform: "translateY(-2px)" }}
//             >
//               <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                 <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", border: "1px solid", ...color }}>{icon}</span>
//               </div>
//               <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{label}</p>
//               <span style={{ display: "inline-flex", alignItems: "center", marginTop: "4px", padding: "1px 6px", borderRadius: "9999px", fontSize: "10px", fontWeight: "500", border: "1px solid", ...badge }}>
//                 {count} entries
//               </span>
//             </HoverButton>
//           ))}
//         </div>

//         {/* Main Log Data Grid Window */}
//         <div style={{ backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>

//           {/* Search Inputs Header Controls */}
//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", flexWrap: "wrap", itemsCenter: "center", justifyContent: "space-between", gap: "12px" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//               <Inbox size={15} style={{ color: THEME.primary }} />
//               <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Webhook Activity Logs</h3>
//             </div>

//             {/* Custom Interactive Search input integration */}
//             <div style={{ position: "relative", width: "100%", maxWidth: "360px" }}>
//               <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, display: "flex", alignItems: "center" }}>
//                 <Search size={14} />
//               </span>
//               <input 
//                 type="text" 
//                 placeholder="Search by Mobile Number..." 
//                 value={searchTerm} 
//                 onChange={handleSearch} 
//                 style={{ 
//                   width: "100%", padding: "8px 12px 8px 34px", fontSize: "13px", borderRadius: "8px", 
//                   border: `1px solid ${THEME.border}`, outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
//                 }} 
//               />
//             </div>
//           </div>

//           {/* Table Element Content Container */}
//           <div style={{ overflowX: "auto", width: "100%" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ borderBottom: `1px solid ${THEME.border}`, backgroundColor: "rgba(241,245,249,0.5)" }}>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>ID</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Customer Mobile</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Status</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Message</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((item) => (
//                     <tr key={item.id} style={{ borderBottom: `1px solid ${THEME.border}`, transition: "background-color 0.2s" }}>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{item.id}</span>
//                       </td>
//                       <td style={{ padding: "14px 20px", fontWeight: "500" }}>
//                         {item.waid ? (
//                           <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                         ) : (
//                           <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                         )}
//                       </td>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{ 
//                           display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500", 
//                           textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read) 
//                         }}>
//                           {item.status || "Unknown"}
//                         </span>
//                       </td>
//                       <td 
//                         onClick={() => handleMessageClick(item)} 
//                         style={{ padding: "14px 20px", maxWidth: "260px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: 'pointer', color: '#2563eb' }}
//                       >
//                         {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                       </td>
//                       <td style={{ padding: "14px 20px", color: THEME.mutedForeground, whiteSpace: "nowrap" }}>
//                         {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={5} style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground }}>No logs matching selected conditions.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Table Pagination Actions block panel */}
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: `1px solid ${THEME.border}`, backgroundColor: "#fafafa" }}>
//             <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>
//               Showing {filteredData.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
//             </p>
//             <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//               <button 
//                 onClick={() => paginate(currentPage - 1)} 
//                 disabled={currentPage === 1} 
//                 style={{ 
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === 1 ? "#94a3b8" : THEME.foreground, 
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' 
//                 }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px", fontWeight: "600", padding: "0 8px", color: THEME.foreground }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button 
//                 onClick={() => paginate(currentPage + 1)} 
//                 disabled={currentPage === totalPages} 
//                 style={{ 
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === totalPages ? "#94a3b8" : THEME.foreground, 
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' 
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Phone, BadgeCheck, Star, Activity, Send, CheckCheck, Inbox, Eye, MailOpen, ArrowRight, Search, ArrowLeft
// } from "lucide-react";

// // --- Theme Definition ---
// const THEME = {
//   background: "#f8fafc",
//   foreground: "#0f172a",
//   muted: "#f1f5f9",
//   mutedForeground: "#64748b",
//   border: "#e2e8f0",
//   primary: "#6366f1",
//   primaryForeground: "#ffffff",
//   card: "#ffffff",
// };

// const STATUS_BADGE = {
//   sent: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
//   delivered: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" },
//   read: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" },
//   received: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" },
// };

// // --- Sub-component: ProgressBar ---
// function ProgressBar({ label, current, max }) {
//   const numericCurrent = Number(current) || 0;
//   const numericMax = typeof max === 'string' ? Number(max.replace(/,/g, '')) : Number(max) || 1;
//   const pct = Math.min(Math.round((numericCurrent / numericMax) * 100), 100);

//   return (
//     <div style={{ marginBottom: "16px" }}>
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
//         <span style={{ fontSize: "12px", fontWeight: 500, color: THEME.foreground }}>{label}</span>
//         <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{numericCurrent.toLocaleString()} / {max.toLocaleString()}</span>
//       </div>
//       <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
//         <div 
//           style={{ 
//             height: "100%", 
//             backgroundColor: THEME.primary, 
//             borderRadius: "9999px", 
//             transition: "all 0.3s ease", 
//             width: `${pct}%` 
//           }} 
//         />
//       </div>
//       <p style={{ fontSize: "10px", color: THEME.mutedForeground, marginTop: "4px", margin: "4px 0 0 0" }}>{pct}% used</p>
//     </div>
//   );
// }

// // --- Sub-component: HoverButton ---
// function HoverButton({ onClick, children, baseStyle, hoverStyle }) {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <button
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       style={{ ...baseStyle, ...(isHovered ? hoverStyle : {}) }}
//     >
//       {typeof children === "function" ? children(isHovered) : children}
//     </button>
//   );
// }

// const Dashboard = () => {
//   // --- All original state hooks ---
//   const [apiData, setApiData] = useState(null);
//   const [contactsCount, setContactsCount] = useState(0);
//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');

//   // New State to manage hiding layouts on menu clicks
//   const [isLogViewOnly, setIsLogViewOnly] = useState(false);

//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));

//   // --- Original Hook 1: Fetch user metadata ---
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
//     if (!emailToUse) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//       .then((response) => {
//         const userData = response.data;
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);

//           fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//             .then((res) => res.json())
//             .then((data) => {
//               if (data?.data?.length > 0) {
//                 const {
//                   display_phone_number, verified_name, quality_rating, code_verification_status,
//                 } = data.data[0];

//                 setApiData({
//                   phoneNumber: display_phone_number,
//                   displayName: verified_name,
//                   qualityRating: quality_rating,
//                   codeverificationstatus: code_verification_status,
//                 });
//               }
//             });
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // --- Original Hook 2: Contacts Count ---
//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;

//     const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
//     if (!finalUserId) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//       .then((response) => {
//         const contacts = response.data.contacts || [];
//         setContactsCount(contacts.length);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch contacts:", error);
//       });
//   }, []);

//   // --- Original Hook 3: Template Status Counts ---
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });
//   }, [waId]);

//   // --- Original Hook 4: Webhook table fetch ---
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table;
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );
//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);

//   // --- Original Count Computations ---
//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;
//   const readMessagesCount = webhookData.filter(item => item.status === 'read').length;
//   const receivedMessagesCount = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '').length;

//   // --- Helper Handlers ---
//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'receivedMessage') {
//       filtered = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType || filterType === '');
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//     setIsLogViewOnly(true); // Triggers layout hide condition
//   };

//   const handleBackToDashboard = () => {
//     setIsLogViewOnly(false); // Restores layout elements
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const filtered = webhookData.filter(item =>
//       item.waid?.includes(value) || item.customer_mobile?.includes(value)
//     );
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   // --- Pagination Slice Calculations ---
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

//   // --- Navigation Tab Configuration mappings ---
//   const TABS = [
//     { label: "Sent", statusFilter: "sent", icon: <Send size={13} />, count: sentMessagesCount, color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" } },
//     { label: "Delivered", statusFilter: "delivered", icon: <CheckCheck size={13} />, count: deliveredMessagesCount, color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } },
//     { label: "Read", statusFilter: "read", icon: <Eye size={13} />, count: readMessagesCount, color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } },
//     { label: "Received Message", statusFilter: "receivedMessage", icon: <MailOpen size={13} />, count: receivedMessagesCount, color: { color: "#7c3aed", backgroundColor: "#f5f3ff", borderColor: "#ddd6fe" }, badge: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" } },
//   ];

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif", padding: "20px" }}>

//       {/* Injecting media queries dynamically for small viewport layout switches */}
//       <style>{`
//         .desktop-table-container { display: block; }
//         .mobile-cards-container { display: none; }
//         @media (max-width: 768px) {
//           .desktop-table-container { display: none; }
//           .mobile-cards-container { display: flex; flexDirection: column; gap: 12px; padding: 12px; }
//         }
//       `}</style>

//       {/* Header section */}
//       <div style={{ paddingBottom: "20px" }}>
//         <h1 style={{ fontSize: "22px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Dashboard</h1>
//         <p style={{ fontSize: "14px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Overview of your chatbot activity</p>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

//         {/* CONDITIONALLY RENDERED SEGMENT: Only visible if a menu filter hasn't been chosen */}
//         {!isLogViewOnly && (
//           <>
//             {/* Meta Stats Row */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//               {[
//                 { icon: <Phone size={15} />, label: "Phone Number", value: apiData?.phoneNumber || '—', color: { color: "#4f46e5", backgroundColor: "#e0e7ff" } },
//                 { icon: <BadgeCheck size={15} />, label: "Display Name", value: apiData?.displayName || '—', color: { color: "#0284c7", backgroundColor: "#e0f2fe" } },
//                 { 
//                   icon: <Star size={15} />, 
//                   label: "Quality Rating", 
//                   value: (
//                     <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
//                       <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: apiData?.qualityRating === 'GREEN' ? "#10b981" : "#f59e0b" }} />
//                       {apiData?.qualityRating === 'GREEN' ? 'High' : apiData?.qualityRating ? 'Low' : '—'}
//                     </span>
//                   ), 
//                   color: apiData?.qualityRating === 'GREEN' ? { color: "#059669", backgroundColor: "#ecfdf5" } : { color: "#d97706", backgroundColor: "#fef3c7" }
//                 },
//                 { icon: <Activity size={15} />, label: "Status", value: apiData?.codeverificationstatus ? String(apiData.codeverificationstatus).toUpperCase() : '—', color: { color: "#dc2626", backgroundColor: "#fee2e2" } },
//               ].map(({ icon, label, value, color }) => (
//                 <div key={label} style={{ flex: "1 1 220px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", ...color }}>{icon}</span>
//                   <p style={{ fontSize: "11px", color: THEME.mutedForeground, fontWeight: "500", letterSpacing: "0.05em", margin: "0 0 2px 0" }}>{label.toUpperCase()}</p>
//                   <p style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{value}</p>
//                 </div>
//               ))}
//             </div>

//             {/* Analytics Row */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
//               {/* Messaging Card */}
//               <div style={{ flex: "2 1 350px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
//                   <Send size={15} style={{ color: THEME.primary }} />
//                   <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Messaging Overview</h3>
//                 </div>
//                 <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                     <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Send size={16} style={{ color: THEME.primary }} /></div>
//                     <div>
//                       <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES SENT</p>
//                       <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>{sentMessagesCount.toLocaleString()}</p>
//                     </div>
//                   </div>
//                   <div style={{ height: "1px", backgroundColor: THEME.border }} />
//                   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                     <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#ecfdf5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><CheckCheck size={16} style={{ color: "#059669" }} /></div>
//                     <div>
//                       <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES DELIVERED</p>
//                       <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>{deliveredMessagesCount.toLocaleString()}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Usage Service Plans Card */}
//               <div style={{ flex: "3 1 450px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                     <Activity size={15} style={{ color: THEME.primary }} />
//                     <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Plan Resource Usage</h3>
//                   </div>
//                   <span style={{ fontSize: "12px", padding: "2px 8px", backgroundColor: THEME.muted, color: THEME.foreground, borderRadius: "9999px", fontWeight: "500" }}>Startup Plan</span>
//                 </div>
//                 <div>
//                   <ProgressBar 
//                     label="Message Templates" 
//                     current={templateCount} 
//                     max={loggedInUser?.email === "vckumar555@gmail.com" ? 100 : 250} 
//                   />
//                   <ProgressBar 
//                     label="Contacts" 
//                     current={contactsCount} 
//                     max={loggedInUser?.email === "vckumar555@gmail.com" ? 50000 : 20000} 
//                   />
//                   <ProgressBar 
//                     label="Messages Sent" 
//                     current={sentMessagesCount} 
//                     max={loggedInUser?.email === "vckumar555@gmail.com" ? 25000 : 50000} 
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Filter Navigation Options Bar */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
//               <HoverButton
//                 onClick={() => navigate('/send-messaging')}
//                 baseStyle={{
//                   flex: "1 1 150px", backgroundColor: THEME.primary, borderRadius: "12px", border: `1px solid ${THEME.primary}`,
//                   padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease-in-out", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
//               >
//                 {(hovered) => (
//                   <>
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px", width: "100%" }}>
//                       <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.2)", color: "#ffffff" }}>
//                         <Send size={13} />
//                       </span>
//                       <ArrowRight size={13} style={{ color: "rgba(255,255,255,0.6)", marginLeft: "auto", transform: hovered ? "translateX(2px)" : "none", transition: "all 0.2s" }} />
//                     </div>
//                     <p style={{ fontSize: "13px", fontWeight: "600", color: "#ffffff", margin: 0 }}>Compose</p>
//                     <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.7)", marginTop: "1px", margin: 0 }}>Send Messaging</p>
//                   </>
//                 )}
//               </HoverButton>

//               <HoverButton
//                 onClick={() => filterData('')}
//                 baseStyle={{
//                   flex: "1 1 140px", backgroundColor: status === '' ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === '' ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                   padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)" }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f1f5f9", color: THEME.foreground }}>
//                     <Inbox size={13} />
//                   </span>
//                 </div>
//                 <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>All</p>
//                 <p style={{ fontSize: "11px", color: THEME.mutedForeground, marginTop: "1px", margin: 0 }}>{webhookData.length} total logs</p>
//               </HoverButton>

//               {TABS.map(({ label, statusFilter, icon, count, color, badge }) => (
//                 <HoverButton
//                   key={label}
//                   onClick={() => filterData(statusFilter)}
//                   baseStyle={{
//                     flex: "1 1 160px", backgroundColor: status === statusFilter ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === statusFilter ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                     padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                   }}
//                   hoverStyle={{ transform: "translateY(-2px)" }}
//                 >
//                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                     <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", border: "1px solid", ...color }}>{icon}</span>
//                   </div>
//                   <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{label}</p>
//                   <span style={{ display: "inline-flex", alignItems: "center", marginTop: "4px", padding: "1px 6px", borderRadius: "9999px", fontSize: "10px", fontWeight: "500", border: "1px solid", ...badge }}>
//                     {count} entries
//                   </span>
//                 </HoverButton>
//               ))}
//             </div>
//           </>
//         )}

//         {/* Main Log Data Grid Window */}
//         <div style={{ backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>

//           {/* Search Inputs Header Controls */}
//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//               {isLogViewOnly && (
//                 <button 
//                   onClick={handleBackToDashboard}
//                   style={{
//                     display: "inline-flex", alignItems: "center", gap: "6px", backgroundColor: "transparent", 
//                     border: `1px solid ${THEME.border}`, padding: "6px 12px", borderRadius: "6px", cursor: "pointer",
//                     fontSize: "12px", fontWeight: "500", color: THEME.foreground, transition: "background-color 0.2s"
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = THEME.muted}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//                 >
//                   <ArrowLeft size={14} /> Back
//                 </button>
//               )}
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <Inbox size={15} style={{ color: THEME.primary }} />
//                 <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Webhook Activity Logs</h3>
//               </div>
//             </div>

//             <div style={{ position: "relative", width: "100%", maxWidth: "360px" }}>
//               <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, display: "flex", alignItems: "center" }}>
//                 <Search size={14} />
//               </span>
//               <input 
//                 type="text" 
//                 placeholder="Search by Mobile Number..." 
//                 value={searchTerm} 
//                 onChange={handleSearch} 
//                 style={{ 
//                   width: "100%", padding: "8px 12px 8px 34px", fontSize: "13px", borderRadius: "8px", 
//                   border: `1px solid ${THEME.border}`, outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
//                 }} 
//               />
//             </div>
//           </div>

//           {/* 1. DESKTOP VIEW LAYOUT: Renders a structured Table Grid layout above 768px */}
//           <div className="desktop-table-container" style={{ overflowX: "auto", width: "100%" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ borderBottom: `1px solid ${THEME.border}`, backgroundColor: "rgba(241,245,249,0.5)" }}>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>ID</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Customer Mobile</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Status</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Message</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((item) => (
//                     <tr key={item.id} style={{ borderBottom: `1px solid ${THEME.border}`, transition: "background-color 0.2s" }}>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{item.id}</span>
//                       </td>
//                       <td style={{ padding: "14px 20px", fontWeight: "500" }}>
//                         {item.waid ? (
//                           <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                         ) : (
//                           <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                         )}
//                       </td>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{ 
//                           display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500", 
//                           textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read) 
//                         }}>
//                           {item.status || "Unknown"}
//                         </span>
//                       </td>
//                       <td 
//                         onClick={() => handleMessageClick(item)} 
//                         style={{ padding: "14px 20px", maxWidth: "260px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: 'pointer', color: '#2563eb' }}
//                       >
//                         {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                       </td>
//                       <td style={{ padding: "14px 20px", color: THEME.mutedForeground, whiteSpace: "nowrap" }}>
//                         {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={5} style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground }}>No logs matching selected conditions.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* 2. MOBILE CARD VIEW LAYOUT: Removes tables entirely on screens below 768px */}
//           <div className="mobile-cards-container">
//             {currentItems.length > 0 ? (
//               currentItems.map((item) => (
//                 <div key={item.id} style={{ backgroundColor: THEME.card, border: `1px solid ${THEME.border}`, borderRadius: "8px", padding: "14px", display: "flex", flexDirection: "column", gap: "8px" }}>
//                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <span style={{ fontFamily: "monospace", fontSize: "11px", color: THEME.mutedForeground }}>ID: {item.id}</span>
//                     <span style={{ 
//                       display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "10px", fontWeight: "500", 
//                       textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read) 
//                     }}>
//                       {item.status || "Unknown"}
//                     </span>
//                   </div>

//                   <div>
//                     <p style={{ margin: 0, fontSize: "11px", color: THEME.mutedForeground }}>Customer Mobile</p>
//                     <p style={{ margin: "2px 0 0 0", fontSize: "13px", fontWeight: "600" }}>
//                       {item.waid ? (
//                         <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                       ) : (
//                         <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                       )}
//                     </p>
//                   </div>

//                   <div>
//                     <p style={{ margin: 0, fontSize: "11px", color: THEME.mutedForeground }}>Received Message</p>
//                     <p 
//                       onClick={() => handleMessageClick(item)} 
//                       style={{ margin: "2px 0 0 0", fontSize: "13px", color: '#2563eb', cursor: "pointer", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
//                     >
//                       {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                     </p>
//                   </div>

//                   <div style={{ display: "flex", justifyContent: "flex-end", borderTop: `1px solid ${THEME.muted}`, paddingTop: "6px" }}>
//                     <span style={{ fontSize: "11px", color: THEME.mutedForeground }}>
//                       {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                     </span>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div style={{ padding: "20px", textAlign: "center", color: THEME.mutedForeground, fontSize: "13px" }}>
//                 No logs matching selected conditions.
//               </div>
//             )}
//           </div>

//           {/* Table Pagination Actions block panel */}
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: `1px solid ${THEME.border}`, backgroundColor: "#fafafa" }}>
//             <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>
//               Showing {filteredData.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
//             </p>
//             <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//               <button 
//                 onClick={() => paginate(currentPage - 1)} 
//                 disabled={currentPage === 1} 
//                 style={{ 
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === 1 ? "#94a3b8" : THEME.foreground, 
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' 
//                 }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px", fontWeight: "600", padding: "0 8px", color: THEME.foreground }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button 
//                 onClick={() => paginate(currentPage + 1)} 
//                 disabled={currentPage === totalPages} 
//                 style={{ 
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === totalPages ? "#94a3b8" : THEME.foreground, 
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' 
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Phone, BadgeCheck, Star, Activity, Send, CheckCheck, Inbox, Eye, MailOpen, ArrowRight, Search, ArrowLeft, TrendingUp
// } from "lucide-react";

// // --- Theme Definition ---
// const THEME = {
//   background: "#f8fafc",
//   foreground: "#0f172a",
//   muted: "#f1f5f9",
//   mutedForeground: "#64748b",
//   border: "#e2e8f0",
//   primary: "#6366f1",
//   primaryForeground: "#ffffff",
//   card: "#ffffff",
//   fail:"#ff0000"
// };

// const STATUS_BADGE = {
//   sent: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" },
//   delivered: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" },
//   read: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" },
//   received: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" },
// };

// // --- Sub-component: ProgressBar ---
// function ProgressBar({ label, current, max }) {
//   const numericCurrent = Number(current) || 0;
//   const numericMax = typeof max === 'string' ? Number(max.replace(/,/g, '')) : Number(max) || 1;
//   const pct = Math.min(Math.round((numericCurrent / numericMax) * 100), 100);

//   return (
//     <div style={{ marginBottom: "16px" }}>
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
//         <span style={{ fontSize: "12px", fontWeight: 500, color: THEME.foreground }}>{label}</span>
//         <span style={{ fontSize: "12px", color: THEME.mutedForeground }}>{numericCurrent.toLocaleString()}
//            {/* / {max.toLocaleString()} */}
//            </span>
//       </div>
//       <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
//         <div 
//           style={{ 
//             height: "100%", 
//             backgroundColor: THEME.primary, 
//             borderRadius: "9999px", 
//             transition: "all 0.3s ease", 
//             width: `${pct}%` 
//           }} 
//         />
//       </div>
//       {/* <p style={{ fontSize: "10px", color: THEME.mutedForeground, marginTop: "4px", margin: "4px 0 0 0" }}>{pct}% used</p> */}
//     </div>
//   );
// }

// // --- Sub-component: HoverButton ---
// function HoverButton({ onClick, children, baseStyle, hoverStyle }) {
//   const [isHovered, setIsHovered] = useState(false);
//   return (
//     <button
//       onClick={onClick}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       style={{ ...baseStyle, ...(isHovered ? hoverStyle : {}) }}
//     >
//       {typeof children === "function" ? children(isHovered) : children}
//     </button>
//   );
// }

// const Dashboard = ({successPct = 85, 
//   success = 85, 
//   total = 100, 
//   failed = 10, 
//   sent = 5}) => {
//   // --- All state hooks ---
//   const [apiData, setApiData] = useState(null);
//   const [contactsCount, setContactsCount] = useState(0);
//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');

//   // Hidden views layout tracker state logic
//   const [isLogViewOnly, setIsLogViewOnly] = useState(false);

//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));

//   // --- Hook 1: Fetch user metadata ---
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
//     if (!emailToUse) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//       .then((response) => {
//         const userData = response.data;
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);

//           fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//             .then((res) => res.json())
//             .then((data) => {
//               if (data?.data?.length > 0) {
//                 const {
//                   display_phone_number, verified_name, quality_rating, code_verification_status,
//                 } = data.data[0];

//                 setApiData({
//                   phoneNumber: display_phone_number,
//                   displayName: verified_name,
//                   qualityRating: quality_rating,
//                   codeverificationstatus: code_verification_status,
//                 });
//               }
//             });
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // --- Hook 2: Contacts Count ---
//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;

//     const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
//     if (!finalUserId) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//       .then((response) => {
//         const contacts = response.data.contacts || [];
//         setContactsCount(contacts.length);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch contacts:", error);
//       });
//   }, []);

//   // --- Hook 3: Template Status Counts ---
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });
//   }, [waId]);

//   // --- Hook 4: Webhook table fetch ---
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table;
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );
//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);
// console.log('this webhookData',webhookData)
//   // --- Count Computations ---
//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;
//   const readMessagesCount = webhookData.filter(item => item.status === 'read').length;
//   const receivedMessagesCount = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '').length;

//   const failedCount = webhookData.filter(item => item.status === '"failed"').length;
//   // --- Handlers ---
//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'receivedMessage') {
//       filtered = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType || filterType === '');
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//     setIsLogViewOnly(true); // Switches off tracking display cards
//   };

//   const handleBackToDashboard = () => {
//     setIsLogViewOnly(false); // Restores grid cards
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const filtered = webhookData.filter(item =>
//       item.waid?.includes(value) || item.customer_mobile?.includes(value)
//     );
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   // --- Pagination calculations ---
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

//   const TABS = [
//     { label: "Sent", statusFilter: "sent", icon: <Send size={13} />, count: sentMessagesCount, color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" } },
//     { label: "Delivered", statusFilter: "delivered", icon: <CheckCheck size={13} />, count: deliveredMessagesCount, color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } },
//     { label: "Read", statusFilter: "read", icon: <Eye size={13} />, count: readMessagesCount, color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } },
//     { label: "Received Message", statusFilter: "receivedMessage", icon: <MailOpen size={13} />, count: receivedMessagesCount, color: { color: "#7c3aed", backgroundColor: "#f5f3ff", borderColor: "#ddd6fe" }, badge: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" } },
//   ];

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif", padding: "20px" }}>

//       {/* Global Responsive Layout Configuration Style Blocks */}
//       <style>{`
//         .desktop-table-view { display: block; }
//         .mobile-cards-view { display: none; }

//         @media (max-width: 768px) {
//           .desktop-table-view { display: none !important; }
//           .mobile-cards-view { 
//             display: block !important; 
//             padding: 10px 16px;
//           }
//           .mobile-card-row {
//             background-color: #ffffff;
//             border-bottom: 1px solid ${THEME.border};
//             padding: 16px 0;
//             display: flex;
//             flex-direction: column;
//             gap: 10px;
//           }
//           .mobile-card-row:last-child {
//             border-bottom: none;
//           }
//         }
//       `}</style>

//       {/* Header section */}
//       <div style={{ paddingBottom: "20px" }}>
//         <h1 style={{ fontSize: "22px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Dashboard</h1>
//         <p style={{ fontSize: "14px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Overview of your chatbot activity</p>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

//         {/* Hiding remaining dashboards segments if true */}
//         {!isLogViewOnly && (
//           <>
//             {/* Meta Stats Row */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//               {[
//                 { icon: <Phone size={15} />, label: "Phone Number", value: apiData?.phoneNumber || '—', color: { color: "#4f46e5", backgroundColor: "#e0e7ff" } },
//                 { icon: <BadgeCheck size={15} />, label: "Display Name", value: apiData?.displayName || '—', color: { color: "#0284c7", backgroundColor: "#e0f2fe" } },
//                 { 
//                   icon: <Star size={15} />, 
//                   label: "Quality Rating", 
//                   value: (
//                     <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
//                       <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: apiData?.qualityRating === 'GREEN' ? "#10b981" : "#f59e0b" }} />
//                       {apiData?.qualityRating === 'GREEN' ? 'High' : apiData?.qualityRating ? 'Low' : '—'}
//                     </span>
//                   ), 
//                   color: apiData?.qualityRating === 'GREEN' ? { color: "#059669", backgroundColor: "#ecfdf5" } : { color: "#d97706", backgroundColor: "#fef3c7" }
//                 },
//                 { icon: <Activity size={15} />, label: "Status", value: apiData?.codeverificationstatus ? String(apiData.codeverificationstatus).toUpperCase() : '—', color: { color: "#dc2626", backgroundColor: "#fee2e2" } },
//               ].map(({ icon, label, value, color }) => (
//                 <div key={label} style={{ flex: "1 1 220px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", ...color }}>{icon}</span>
//                   <p style={{ fontSize: "11px", color: THEME.mutedForeground, fontWeight: "500", letterSpacing: "0.05em", margin: "0 0 2px 0" }}>{label.toUpperCase()}</p>
//                   <p style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{value}</p>
//                 </div>
//               ))}
//             </div>
// <div style={{
//       backgroundColor: 'var(--card, #ffffff)',
//       borderRadius: '0.75rem',
//       border: '1px solid var(--border, #e2e8f0)',
//       padding: '1rem',
//       boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '1rem',
//       // Simulating Tailwind's sm:flex-row via responsive CSS check or standard flex wrap alternatives if needed, 
//       // but standard inline approach uses a fallback or layout block.
//       // Below uses standard modern CSS layout properties:
//       flexFlow: 'row wrap', 
//       alignItems: 'center'
//     }}>

//       {/* Left Section: Icon and Metric */}
//       <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flex: '1 1 0%' }}>
//         <div style={{
//           width: '2.5rem',
//           height: '2.5rem',
//           borderRadius: '0.75rem',
//           backgroundColor: '#ecfdf5', // bg-emerald-50 (Note: for dark mode you'd typically handle this via media queries)
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           flexShrink: 0
//         }}>
//           <TrendingUp size={18} style={{ color: '#059669' }} />
//         </div>
//         <div>
//           <p style={{
//             fontSize: '11px',
//             color: 'var(--muted-foreground, #64748b)',
//             fontWeight: 500,
//             textTransform: 'uppercase',
//             letterSpacing: '0.05em',
//             margin: 0
//           }}>
//             Delivery Success Factor
//           </p>
//           <p style={{
//             fontSize: '1.5rem',
//             fontWeight: 700,
//             color: 'var(--foreground, #0f172a)',
//             fontFamily: "'Plus Jakarta Sans', sans-serif",
//             margin: 0
//           }}>
//             {successPct}%
//           </p>
//         </div>
//       </div>

//       {/* Right Section: Progress Bar and Detailed Metrics */}
//       <div style={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.375rem' }}>
//           <span style={{ fontSize: '0.75rem', color: 'var(--muted-foreground, #64748b)' }}>
//             {success} successful transactions of {total} total items
//           </span>
//           <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#059669' }}>
//             {successPct}%
//           </span>
//         </div>

//         {/* Outer Progress Bar Track */}
//         <div style={{
//           height: '0.625rem',
//           backgroundColor: 'var(--muted, #f1f5f9)',
//           borderRadius: '9999px',
//           overflow: 'hidden'
//         }}>
//           {/* Inner Progress Bar Fill */}
//           <div style={{
//             height: '100%',
//             backgroundColor: '#10b981',
//             borderRadius: '9999px',
//             transition: 'all 0.2s ease-in-out',
//             width: `${successPct}%`
//           }} />
//         </div>

//         {/* Legend / Status Labels */}
//         <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginTop: '0.5rem', flexWrap: 'wrap' }}>
//           <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '11px', color: '#059669', fontWeight: 500 }}>
//             <span style={{ width: '0.5rem', height: '0.5rem', borderRadius: '50%', backgroundColor: '#10b981', display: 'inline-block' }} /> 
//             {success} Success / Delivered
//           </span>

//           <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '11px', color: '#ef4444', fontWeight: 500 }}>
//             <span style={{ width: '0.5rem', height: '0.5rem', borderRadius: '50%', backgroundColor: '#ef4444', display: 'inline-block' }} /> 
//             {failed} Failed Logs
//           </span>

//           <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '11px', color: 'var(--muted-foreground, #64748b)', fontWeight: 500 }}>
//             <span style={{ width: '0.5rem', height: '0.5rem', borderRadius: '50%', backgroundColor: '#94a3b8', display: 'inline-block' }} /> 
//             {sent} Pending Outbound
//           </span>
//         </div>
//       </div>

//     </div>
//             {/* Analytics Row */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
//               {/* Messaging Card */}
//               <div style={{ flex: "2 1 350px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
//                   <Send size={15} style={{ color: THEME.primary }} />
//                   <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Messaging Overview</h3>
//                 </div>
//                 <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//                   {/* <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                     <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Send size={16} style={{ color: THEME.primary }} /></div>
//                     <div>
//                       <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES SENT</p>
//                       <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>{sentMessagesCount.toLocaleString()}</p>
//                     </div>
//                   </div> */}

//                   <div style={{ height: "1px", backgroundColor: THEME.border }} />
//                   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                     <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#ecfdf5", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><CheckCheck size={16} style={{ color: "#059669" }} /></div>
//                     <div>
//                       <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES DELIVERED</p>
//                       <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>{deliveredMessagesCount.toLocaleString()}</p>
//                     </div>
//                   </div>
//   <div style={{ height: "1px", backgroundColor: THEME.border }} />
//                     <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//                     <div style={{ width: "40px", height: "40px", borderRadius: "12px", backgroundColor: "#ffe0f8", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                       <Send size={16} style={{ color: THEME.fail }} /></div>
//                     <div>
//                       <p style={{ fontSize: "10px", color: THEME.mutedForeground, fontWeight: "500", margin: 0 }}>MESSAGES Failed</p>
//                       <p style={{ fontSize: "24px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>{failedCount.toLocaleString()}</p>
//                     </div>
//                   </div>

//                   <div style={{ height: "1px", backgroundColor: THEME.border }} />
//                 </div>
//               </div>

//               {/* Usage Service Plans Card */}
//               <div style={{ flex: "3 1 450px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                     <Activity size={15} style={{ color: THEME.primary }} />
//                     <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Resource Count</h3>
//                   </div>
//                   {/* <span style={{ fontSize: "12px", padding: "2px 8px", backgroundColor: THEME.muted, color: THEME.foreground, borderRadius: "9999px", fontWeight: "500" }}>Count</span> */}
//                 </div>
//                 <div>
//                   <ProgressBar 
//                     label="Message Templates" 
//                     current={templateCount} 
//                     max={loggedInUser?.email === "vckumar555@gmail.com" ? 100 : 250} 
//                   />
//                   <ProgressBar 
//                     label="Contacts" 
//                     current={contactsCount} 
//                     max={loggedInUser?.email === "vckumar555@gmail.com" ? 50000 : 20000} 
//                   />
//                   <ProgressBar 
//                     label="Messages Sent" 
//                     current={sentMessagesCount} 
//                     max={loggedInUser?.email === "vckumar555@gmail.com" ? 25000 : 50000} 
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Filter Navigation Options Bar */}
//             {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
//               <HoverButton
//                 onClick={() => navigate('/send-messaging')}
//                 baseStyle={{
//                   flex: "1 1 150px", backgroundColor: THEME.primary, borderRadius: "12px", border: `1px solid ${THEME.primary}`,
//                   padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease-in-out", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
//               >
//                 {(hovered) => (
//                   <>
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px", width: "100%" }}>
//                       <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(255,255,255,0.2)", color: "#ffffff" }}>
//                         <Send size={13} />
//                       </span>
//                       <ArrowRight size={13} style={{ color: "rgba(255,255,255,0.6)", marginLeft: "auto", transform: hovered ? "translateX(2px)" : "none", transition: "all 0.2s" }} />
//                     </div>
//                     <p style={{ fontSize: "13px", fontWeight: "600", color: "#ffffff", margin: 0 }}>Compose</p>
//                     <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.7)", marginTop: "1px", margin: 0 }}>Send Messaging</p>
//                   </>
//                 )}
//               </HoverButton>

//               <HoverButton
//                 onClick={() => filterData('')}
//                 baseStyle={{
//                   flex: "1 1 140px", backgroundColor: status === '' ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === '' ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                   padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease"
//                 }}
//                 hoverStyle={{ transform: "translateY(-2px)" }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f1f5f9", color: THEME.foreground }}>
//                     <Inbox size={13} />
//                   </span>
//                 </div>
//                 <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>All</p>
//                 <p style={{ fontSize: "11px", color: THEME.mutedForeground, marginTop: "1px", margin: 0 }}>{webhookData.length} total logs</p>
//               </HoverButton>

//               {TABS.map(({ label, statusFilter, icon, count, color, badge }) => (
//                 <HoverButton
//                   key={label}
//                   onClick={() => filterData(statusFilter)}
//                   baseStyle={{
//                     flex: "1 1 160px", backgroundColor: status === statusFilter ? "#f8fafc" : THEME.card, borderRadius: "12px", border: status === statusFilter ? `2px solid ${THEME.primary}` : `1px solid ${THEME.border}`,
//                     padding: "14px 16px", cursor: "pointer", textAlign: "left", transition: "all 0.2s ease", boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
//                   }}
//                   hoverStyle={{ transform: "translateY(-2px)" }}
//                 >
//                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
//                     <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", border: "1px solid", ...color }}>{icon}</span>
//                   </div>
//                   <p style={{ fontSize: "13px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{label}</p>
//                   <span style={{ display: "inline-flex", alignItems: "center", marginTop: "4px", padding: "1px 6px", borderRadius: "9999px", fontSize: "10px", fontWeight: "500", border: "1px solid", ...badge }}>
//                     {count} entries
//                   </span>
//                 </HoverButton>
//               ))}
//             </div> */}
//           </>
//         )}

//         {/* Main Log Data Grid Window */}
//         <div style={{ backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, boxShadow: "0 1px 3px rgba(0,0,0,0.05)", overflow: "hidden" }}>

//           {/* Search Inputs Header Controls */}
//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//               {isLogViewOnly && (
//                 <button 
//                   onClick={handleBackToDashboard}
//                   style={{
//                     display: "inline-flex", alignItems: "center", gap: "6px", backgroundColor: "transparent", 
//                     border: `1px solid ${THEME.border}`, padding: "6px 12px", borderRadius: "6px", cursor: "pointer",
//                     fontSize: "12px", fontWeight: "500", color: THEME.foreground, transition: "background-color 0.2s"
//                   }}
//                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = THEME.muted}
//                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
//                 >
//                   <ArrowLeft size={14} /> Back
//                 </button>
//               )}
//               <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <Inbox size={15} style={{ color: THEME.primary }} />
//                 <h3 style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Webhook Activity Logs</h3>
//               </div>
//             </div>

//             <div style={{ position: "relative", width: "100%", maxWidth: "360px" }}>
//               <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, display: "flex", alignItems: "center" }}>
//                 <Search size={14} />
//               </span>
//               <input 
//                 type="text" 
//                 placeholder="Search by Mobile Number..." 
//                 value={searchTerm} 
//                 onChange={handleSearch} 
//                 style={{ 
//                   width: "100%", padding: "8px 12px 8px 34px", fontSize: "13px", borderRadius: "8px", 
//                   border: `1px solid ${THEME.border}`, outline: "none", color: THEME.foreground, backgroundColor: "#fafafa"
//                 }} 
//               />
//             </div>
//           </div>

//           {/* 1. DESKTOP VIEW STANDARD LAYOUT */}
//           <div className="desktop-table-view" style={{ overflowX: "auto", width: "100%" }}>
//             <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
//               <thead>
//                 <tr style={{ borderBottom: `1px solid ${THEME.border}`, backgroundColor: "rgba(241,245,249,0.5)" }}>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>ID</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Customer Mobile</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Status</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Message</th>
//                   <th style={{ padding: "12px 20px", fontSize: "11px", fontWeight: "600", color: THEME.mutedForeground, textTransform: "uppercase" }}>Received Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((item) => (
//                     <tr key={item.id} style={{ borderBottom: `1px solid ${THEME.border}`, transition: "background-color 0.2s" }}>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{ fontFamily: "monospace", fontSize: "12px", color: THEME.mutedForeground }}>{item.id}</span>
//                       </td>
//                       <td style={{ padding: "14px 20px", fontWeight: "500" }}>
//                         {item.waid ? (
//                           <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                         ) : (
//                           <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                         )}
//                       </td>
//                       <td style={{ padding: "14px 20px" }}>
//                         <span style={{ 
//                           display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500", 
//                           textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read) 
//                         }}>
//                           {item.status || "Unknown"}
//                         </span>
//                       </td>
//                       <td 
//                         onClick={() => handleMessageClick(item)} 
//                         style={{ padding: "14px 20px", maxWidth: "260px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: 'pointer', color: '#2563eb' }}
//                       >
//                         {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                       </td>
//                       <td style={{ padding: "14px 20px", color: THEME.mutedForeground, whiteSpace: "nowrap" }}>
//                         {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={5} style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground }}>No logs matching selected conditions.</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* 2. MOBILE VIEW: RENDERS STACKED VERTICALLY ONE AFTER ANOTHER */}
//           <div className="mobile-cards-view">
//             {currentItems.length > 0 ? (
//               currentItems.map((item) => (
//                 <div key={item.id} className="mobile-card-row">
//                   {/* Row 1: ID & Status Badge stacked side by side inside the block line item */}
//                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <span style={{ fontSize: "12px", fontFamily: "monospace", color: THEME.mutedForeground }}>#{item.id}</span>
//                     <span style={{ 
//                       display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: "500", 
//                       textTransform: "capitalize", border: "1px solid", ...(STATUS_BADGE[item.status] || STATUS_BADGE.read) 
//                     }}>
//                       {item.status || "Unknown"}
//                     </span>
//                   </div>

//                   {/* Row 2: Customer Contact Number Label followed by actual Number */}
//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Customer Mobile</div>
//                     <div style={{ fontSize: "14px", fontWeight: "500" }}>
//                       {item.waid ? (
//                         <span style={{ color: "#059669", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                       ) : (
//                         <span style={{ color: "#2563eb", cursor: 'pointer', textDecoration: "underline" }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Row 3: Message Text block description section */}
//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Message</div>
//                     <div 
//                       onClick={() => handleMessageClick(item)} 
//                       style={{ fontSize: "13px", color: '#2563eb', cursor: 'pointer', wordBreak: "break-word" }}
//                     >
//                       {item.receivedMessage || <span style={{ color: THEME.mutedForeground }}>—</span>}
//                     </div>
//                   </div>

//                   {/* Row 4: Timeline Entry Date */}
//                   <div>
//                     <div style={{ fontSize: "11px", color: THEME.mutedForeground, textTransform: "uppercase", fontWeight: "600", marginBottom: "2px" }}>Received Date</div>
//                     <div style={{ fontSize: "13px", color: THEME.foreground }}>
//                       {item.received_date ? new Date(item.received_date).toLocaleDateString() : "—"}
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground, fontSize: "13px" }}>
//                 No logs matching selected conditions.
//               </div>
//             )}
//           </div>

//           {/* Table Pagination Actions block panel */}
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderTop: `1px solid ${THEME.border}`, backgroundColor: "#fafafa" }}>
//             <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>
//               Showing {filteredData.length > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, filteredData.length)} of {filteredData.length} entries
//             </p>
//             <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//               <button 
//                 onClick={() => paginate(currentPage - 1)} 
//                 disabled={currentPage === 1} 
//                 style={{ 
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === 1 ? "#94a3b8" : THEME.foreground, 
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' 
//                 }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px", fontWeight: "600", padding: "0 8px", color: THEME.foreground }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button 
//                 onClick={() => paginate(currentPage + 1)} 
//                 disabled={currentPage === totalPages} 
//                 style={{ 
//                   padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: currentPage === totalPages ? "#94a3b8" : THEME.foreground, 
//                   border: `1px solid ${THEME.border}`, backgroundColor: THEME.card, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' 
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;











































// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { 
//   Send, CheckCheck, Eye, MailOpen, Phone, BadgeCheck, 
//   Star, Activity, Inbox, ArrowLeft, ArrowRight, Search, TrendingUp 
// } from 'lucide-react';
// import ReceivedMessages from '../MessageAnalytics/ReceivedMessage';

// // --- Local Theme Configuration Fallbacks ---
// const THEME = {
//   background: "#f8fafc",
//   foreground: "#0f172a",
//   mutedForeground: "#64748b",
//   card: "#ffffff",
//   border: "#e2e8f0",
//   primary: "#4f46e5",
//   muted: "#f1f5f9",
//   fail: "#ef4444"
// };

// const STATUS_BADGE = {
//   sent: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" },
//   delivered: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" },
//   read: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" },
//   failed: { color: "#ef4444", backgroundColor: "#fef2f2", borderColor: "#fca5a5" }
// };

// // --- Child Helper Components ---
// const ProgressBar = ({ label, current, max }) => {
//   const percentage = Math.min(Math.round((current / max) * 100), 100) || 0;
//   return (
//     <div style={{ marginBottom: "14px" }}>
//       <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px", fontSize: "12px" }}>
//         <span style={{ fontWeight: "500", color: THEME.foreground }}>{label}</span>
//         <span style={{ color: THEME.mutedForeground }}>{current} / {max} ({percentage}%)</span>
//       </div>
//       <div style={{ height: "6px", backgroundColor: THEME.muted, borderRadius: "9999px", overflow: "hidden" }}>
//         <div style={{ height: "100%", width: `${percentage}%`, backgroundColor: THEME.primary, borderRadius: "9999px", transition: "width 0.3s ease" }} />
//       </div>
//     </div>
//   );
// };

// const HoverButton = ({ children, onClick, baseStyle, hoverStyle }) => {
//   const [hovered, setHovered] = useState(false);
//   return (
//     <button
//       onClick={onClick}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{ ...baseStyle, ...(hovered ? hoverStyle : {}), border: baseStyle.border || "none", outline: "none" }}
//     >
//       {typeof children === "function" ? children(hovered) : children}
//     </button>
//   );
// };

// // --- Main Dashboard Component ---
// const Dashboard = () => {
//   // --- All state hooks ---
//   const [apiData, setApiData] = useState(null);
//   const [contactsCount, setContactsCount] = useState(0);
//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');

//   // Hidden views layout tracker state logic
//   const [isLogViewOnly, setIsLogViewOnly] = useState(false);

//   const itemsPerPage = 10;
//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));

//   // --- Hook 1: Fetch user metadata ---
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
//     if (!emailToUse) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//       .then((response) => {
//         const userData = response.data;
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);

//           fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//             .then((res) => res.json())
//             .then((data) => {
//               if (data?.data?.length > 0) {
//                 const {
//                   display_phone_number, verified_name, quality_rating, code_verification_status,
//                 } = data.data[0];

//                 setApiData({
//                   phoneNumber: display_phone_number,
//                   displayName: verified_name,
//                   qualityRating: quality_rating,
//                   codeverificationstatus: code_verification_status,
//                 });
//               }
//             });
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // --- Hook 2: Contacts Count ---
//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;

//     const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
//     if (!finalUserId) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//       .then((response) => {
//         const contacts = response.data.contacts || [];
//         setContactsCount(contacts.length);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch contacts:", error);
//       });
//   }, []);

//   // --- Hook 3: Template Status Counts ---
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });
//   }, [waId]);

//   // --- Hook 4: Webhook table fetch ---
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table;
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );

//         console.log("sortedDataaaaaaaaaaaaaaaaaa",sortedData)

//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);

//   // --- Count Computations ---
//   const totalLogs = webhookData.length;
//   const sentMessagesCount = webhookData.filter(item =>
//    item.status === "sent" || item.status === "session_sent"
//    ).length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;
//   const readMessagesCount = webhookData.filter(item => item.status === 'read').length;
//   const receivedMessagesCount = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '').length;
//   const failedCount = webhookData.filter(item => item.status === 'failed' || item.status === '"failed"').length;
//   const pendingCount = totalLogs - (deliveredMessagesCount + failedCount);

//   // Dynamic success percentages logic based on absolute logs parsed
//   const successPct = totalLogs > 0 ? Math.round((deliveredMessagesCount / totalLogs) * 100) : 0;

//   // --- Handlers ---
//   const filterData = (filterType) => {
//   setStatus(filterType);

//   let filtered = [];

//   if (filterType === "receivedMessage") {
//     filtered = webhookData.filter(
//       item => item.receivedMessage && item.receivedMessage !== ""
//     );
//   } else if (filterType === "sent") {
//     filtered = webhookData.filter(
//       item =>
//         item.status === "sent" ||
//         item.status === "session_sent"
//     );
//   } else {
//     filtered = webhookData.filter(
//       item => item.status === filterType || filterType === ""
//     );
//    }

//    setFilteredData(filtered);
//     setCurrentPage(1);
//  };

//   const handleBackToDashboard = () => {
//     setIsLogViewOnly(false); 
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     const filtered = webhookData.filter(item =>
//       item.waid?.includes(value) || item.customer_mobile?.includes(value)
//     );
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   // --- Pagination calculations ---
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//   const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;

//   const TABS = [
//     { label: "Sent", statusFilter: "sent", icon: <Send size={13} />, count: sentMessagesCount, color: { color: "#2563eb", backgroundColor: "#eff6ff", borderColor: "#bfdbfe" }, badge: { backgroundColor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" } },
//     { label: "Delivered", statusFilter: "delivered", icon: <CheckCheck size={13} />, count: deliveredMessagesCount, color: { color: "#059669", backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }, badge: { backgroundColor: "#ecfdf5", color: "#047857", borderColor: "#a7f3d0" } },
//     { label: "Read", statusFilter: "read", icon: <Eye size={13} />, count: readMessagesCount, color: { color: "#475569", backgroundColor: "#f1f5f9", borderColor: "#e2e8f0" }, badge: { backgroundColor: "#f1f5f9", color: "#475569", borderColor: "#e2e8f0" } },
//     { label: "Received Message", statusFilter: "receivedMessage", icon: <MailOpen size={13} />, count: receivedMessagesCount, color: { color: "#7c3aed", backgroundColor: "#f5f3ff", borderColor: "#ddd6fe" }, badge: { backgroundColor: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" } },
//   ];

//   return (
//     <div style={{ flex: 1, overflowY: "auto", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif",}}>

//       {/* Global Responsive Layout Configuration Style Blocks */}
//       <style>{`
//         .desktop-table-view { display: block; }
//         .mobile-cards-view { display: none; }

//         @media (max-width: 768px) {
//           .desktop-table-view { display: none !important; }
//           .mobile-cards-view { 
//             display: block !important; 
//             padding: 10px 16px;
//           }
//           .mobile-card-row {
//             background-color: #ffffff;
//             border-bottom: 1px solid ${THEME.border};
//             padding: 16px 0;
//             display: flex;
//             flex-direction: column;
//             gap: 10px;
//           }
//           .mobile-card-row:last-child {
//             border-bottom: none;
//           }
//         }
//       `}</style>

//       {/* Header section */}
//       <div style={{ paddingBottom: "20px" }}>
//         <h1 style={{ fontSize: "22px", fontWeight: "bold", color: THEME.foreground, fontFamily: "'Plus Jakarta Sans', sans-serif", margin: 0 }}>Dashboard</h1>
//         <p style={{ fontSize: "14px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Overview of your chatbot activity</p>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

//         {!isLogViewOnly && (
//           <>
//             {/* Meta Stats Row */}
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//               {[
//                 { icon: <Phone size={15} />, label: "Phone Number", value: apiData?.phoneNumber || '—', color: { color: "#4f46e5", backgroundColor: "#e0e7ff" } },
//                 { icon: <BadgeCheck size={15} />, label: "Display Name", value: apiData?.displayName || '—', color: { color: "#0284c7", backgroundColor: "#e0f2fe" } },
//                 { 
//                   icon: <Star size={15} />, 
//                   label: "Quality Rating", 
//                   value: (
//                     <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
//                       <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: apiData?.qualityRating === 'GREEN' ? "#10b981" : "#f59e0b" }} />
//                       {apiData?.qualityRating === 'GREEN' ? 'High' : apiData?.qualityRating ? 'Low' : '—'}
//                     </span>
//                   ), 
//                   color: apiData?.qualityRating === 'GREEN' ? { color: "#059669", backgroundColor: "#ecfdf5" } : { color: "#d97706", backgroundColor: "#fef3c7" }
//                 },
//                 { icon: <Activity size={15} />, label: "MESSAGES SENT", 
//                 // value: apiData?.codeverificationstatus ? String(apiData.codeverificationstatus).toUpperCase() : '—',
//                value: deliveredMessagesCount?.toLocaleString() || "—",

//                  color: { color: "rgb(19, 220, 13)", backgroundColor: "rgba(202, 202, 202, 0.42)" } },
//               ].map(({ icon, label, value, color }) => (
//                 <div key={label} style={{ flex: "1 1 220px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                   <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", ...color }}>{icon}</span>
//                   <p style={{ fontSize: "11px", color: THEME.mutedForeground, fontWeight: "500", letterSpacing: "0.05em", margin: "0 0 2px 0" }}>{label.toUpperCase()}</p>
//                   <p style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{value}</p>
//                 </div>
//               ))}
//             </div>         
//           </>
//         )}


// <ReceivedMessages
//     receivedMessages={webhookData.filter(
//         item => item.receivedMessage && item.receivedMessage !== ""
//     )}
// />
//       </div>
//     </div>
//   );
// };

// export default Dashboard;
























// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Send, MailOpen, Phone, BadgeCheck, Star, Activity, Search, X, ChevronLeft, ChevronRight } from 'lucide-react';

// // --- Global Theme & Configuration Sync ---
// const THEME = {
//   background: "#f8fafc",
//   foreground: "#0f172a",
//   mutedForeground: "#64748b",
//   card: "#ffffff",
//   border: "#e2e8f0",
//   borderLight: "#f1f5f9",
//   primary: "#4f46e5",
//   primaryLight: "#ede9fe",
//   muted: "#f1f5f9",
//   fail: "#ef4444",
//   successBg: "#f0fdf4",
//   successText: "#166534",
//   successBorder: "#bbf7d0",
//   dangerBg: "#fff1f2",
//   dangerText: "#9f1239",
//   dangerBorder: "#fecdd3",
//   whatsappSent: "#d9fdd3",
//   whatsappReceived: "#ffffff"
// };

// const ITEMS_PER_PAGE_CHAT = 6;

// // --- Safe Parsers & Formatters ---
// const parseSafeDate = (dateStr) => {
//   if (!dateStr) return new Date();
//   return new Date(dateStr.replace(" ", "T"));
// };

// const formatChatDate = (dateStr) => {
//   const msgDate = parseSafeDate(dateStr);
//   const today = new Date();
//   const yesterday = new Date();
//   yesterday.setDate(today.getDate() - 1);

//   if (msgDate.toDateString() === today.toDateString()) {
//     return "Today";
//   } else if (msgDate.toDateString() === yesterday.toDateString()) {
//     return "Yesterday";
//   } else {
//     return msgDate.toLocaleDateString(undefined, {
//       weekday: "long",
//       month: "long",
//       day: "numeric",
//       year: "numeric",
//     });
//   }
// };

// const checkIsExpired = (dateString) => {
//   const msgDate = parseSafeDate(dateString).getTime();
//   const currentDate = new Date().getTime();
//   const hoursDifference = (currentDate - msgDate) / (1000 * 60 * 60);
//   return hoursDifference > 24;
// };

// // --- Main Hybrid Dashboard Component ---
// const Dashboard = () => {
//   // --- Core States ---
//   const [apiData, setApiData] = useState(null);
//   const [contactsCount, setContactsCount] = useState(0);
//   const [waId, setWaId] = useState(null);
//   const [templateCount, setTemplateCount] = useState(0);
//   const [webhookData, setWebhookData] = useState([]);
//   const [isLogViewOnly, setIsLogViewOnly] = useState(false);

//   // --- Received / Active Chats Subsystem States ---
//   const [selectedChat, setSelectedChat] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [replyText, setReplyText] = useState("");
//   const [chatSearchQuery, setChatSearchQuery] = useState("");
//   const [chatCurrentPage, setChatCurrentPage] = useState(1);
//   const [conversationMessages, setConversationMessages] = useState([]);
//   const [hoveredRow, setHoveredRow] = useState(null);

//   const navigate = useNavigate();
//   const loggedInUser = JSON.parse(sessionStorage.getItem('user'));
//   const chatEndRef = useRef(null);

//   // Auto Scroll Chat within modal context
//   useEffect(() => {
//     if (isModalOpen) {
//       chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }
//   }, [conversationMessages, isModalOpen]);

//   // --- Data Fetching Hook 1: User metadata ---
//   useEffect(() => {
//     const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//     if (!loggedUser) return;

//     const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
//     if (!emailToUse) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//       .then((response) => {
//         const userData = response.data;
//         if (userData.wa_id) {
//           setWaId(userData.wa_id);

//           fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
//             .then((res) => res.json())
//             .then((data) => {
//               if (data?.data?.length > 0) {
//                 const {
//                   display_phone_number, verified_name, quality_rating, code_verification_status,
//                 } = data.data[0];

//                 setApiData({
//                   phoneNumber: display_phone_number,
//                   displayName: verified_name,
//                   qualityRating: quality_rating,
//                   codeverificationstatus: code_verification_status,
//                 });
//               }
//             });
//         }
//       })
//       .catch((err) => {
//         console.error("Error retrieving user data:", err);
//       });
//   }, []);

//   // --- Hook 2: Contacts Count ---
//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user) return;

//     const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
//     if (!finalUserId) return;

//     axios
//       .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
//       .then((response) => {
//         const contacts = response.data.contacts || [];
//         setContactsCount(contacts.length);
//       })
//       .catch((error) => {
//         console.error("Failed to fetch contacts:", error);
//       });
//   }, []);

//   // --- Hook 3: Template Status Counts ---
//   useEffect(() => {
//     if (!waId) return;
//     fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
//       .then(res => res.text())
//       .then(text => {
//         const jsonStart = text.indexOf('{');
//         const jsonString = text.substring(jsonStart);
//         const data = JSON.parse(jsonString);
//         if (Array.isArray(data?.data)) {
//           setTemplateCount(data.data.length);
//         }
//       })
//       .catch(err => {
//         console.error("Failed to fetch template data:", err);
//       });
//   }, [waId]);

//   // --- Hook 4: Webhook log processor table fetch ---
//   useEffect(() => {
//     const webhookTable = loggedInUser?.webhook_table;
//     if (!webhookTable) return;
//     axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
//       webhook_table: webhookTable
//     })
//       .then((response) => {
//         console.log("sortedresponseData", response.data)
//         const sortedData = response.data.sort((a, b) =>
//           new Date(b.received_date) - new Date(a.received_date)
//         );
//         setWebhookData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);

//   const conversationData = webhookData
//     .filter(item => {
//       // Ignore WhatsApp status callbacks only
//       if (
//         item.status === "sent" ||
//         item.status === "delivered" ||
//         item.status === "read"
//       ) {
//         return false;
//       }

//       return (
//         (item.receivedMessage && item.receivedMessage.trim() !== "") ||
//         (item.sentMessage && item.sentMessage.trim() !== "")
//       );
//     })
//     .map(item => ({
//       id: item.id,
//       mobile: item.customer_mobile || item.waid || "Unknown Number",
//       sender: item.sentMessage ? "You" : "Customer",
//       messageText: item.sentMessage || item.receivedMessage,
//       date: item.received_date
//     }));

//   const messagesSentCount = webhookData.filter(
//     item => item.status === "sent" || item.status === "session_sent"
//   ).length;

//   // --- Interactive Search Filters Mechanism ---
//   const filteredChatMessages = conversationData.filter((msg) => {
//     const query = chatSearchQuery.toLowerCase();
//     return (
//       (msg.mobile || "").toLowerCase().includes(query) ||
//       (msg.messageText || "").toLowerCase().includes(query)
//     );
//   });

//   const uniqueContactsMap = {};
//   filteredChatMessages.forEach(msg => {
//     const mobile = msg.mobile;
//     if (!mobile) return;

//     if (!uniqueContactsMap[mobile]) {
//       uniqueContactsMap[mobile] = { ...msg, summaryMessage: msg.messageText };
//     } else {
//       if (parseSafeDate(msg.date) > parseSafeDate(uniqueContactsMap[mobile].date)) {
//         const currentValidText = msg.messageText || uniqueContactsMap[mobile].summaryMessage;
//         uniqueContactsMap[mobile] = {
//           ...msg,
//           summaryMessage: currentValidText
//         };
//       } else if (!uniqueContactsMap[mobile].summaryMessage && msg.messageText) {
//         uniqueContactsMap[mobile].summaryMessage = msg.messageText;
//       }
//     }
//   });

//   const contactsList = Object.values(uniqueContactsMap).sort((a, b) => parseSafeDate(b.date) - parseSafeDate(a.date));
//   const chatTotalPages = Math.ceil(contactsList.length / ITEMS_PER_PAGE_CHAT) || 1;
//   const chatStartIndex = (chatCurrentPage - 1) * ITEMS_PER_PAGE_CHAT;
//   const paginatedChatMessages = contactsList.slice(chatStartIndex, chatStartIndex + ITEMS_PER_PAGE_CHAT);

//   const handleSelectChat = (msg) => {
//     setSelectedChat(msg);
//     setReplyText("");

//     const conversation = conversationData
//       .filter(item => item.mobile === msg.mobile)
//       .sort((a, b) => parseSafeDate(a.date) - parseSafeDate(b.date))
//       .map(item => ({
//         sender: item.sender,
//         text: item.messageText,
//         received_date: item.date
//       }));

//     setConversationMessages(conversation);
//     setIsModalOpen(true);
//   };

//   const handleSendReply = async (e) => {
//     e.preventDefault();
//     if (!replyText.trim()) return;

//     const user = JSON.parse(sessionStorage.getItem("user"));
//     const payload = {
//       id: user?.wa_id || "",
//       mobile: selectedChat.mobile,
//       message: replyText,
//     };

//     try {
//       await axios.post("https://emedha.com/echatbot/enotifier/client-message.php", payload);
//       setConversationMessages((prev) => [
//         ...prev,
//         {
//           sender: "You",
//           text: replyText,
//           received_date: new Date().toISOString(),
//         },
//       ]);
//       setReplyText("");
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   let lastRenderedDateLabel = null;

//   return (
//     <div style={{ flex: 1, height: "100vh", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif", boxSizing: "border-box" }}>

//       {/* Header section */}
//       <div style={{ paddingBottom: "20px" }}>
//         <h1 style={{ fontSize: "22px", fontWeight: "bold", color: THEME.foreground, margin: 0 }}>Dashboard</h1>
//         <p style={{ fontSize: "14px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Overview of your chatbot activity</p>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>

//         {!isLogViewOnly && (
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
//             {[
//               { icon: <Phone size={15} />, label: "Phone Number", value: apiData?.phoneNumber || '—', color: { color: "#4f46e5", backgroundColor: "#e0e7ff" } },
//               { icon: <BadgeCheck size={15} />, label: "Display Name", value: apiData?.displayName || '—', color: { color: "#0284c7", backgroundColor: "#e0f2fe" } },
//               {
//                 icon: <Star size={15} />,
//                 label: "Quality Rating",
//                 value: (
//                   <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
//                     <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: apiData?.qualityRating === 'GREEN' ? "#10b981" : "#f59e0b" }} />
//                     {apiData?.qualityRating === 'GREEN' ? 'High' : apiData?.qualityRating ? 'Low' : '—'}
//                   </span>
//                 ),
//                 color: apiData?.qualityRating === 'GREEN' ? { color: "#059669", backgroundColor: "#ecfdf5" } : { color: "#d97706", backgroundColor: "#fef3c7" }
//               },
//               { icon: <Activity size={15} />, label: "MESSAGES SENT", value: messagesSentCount.toLocaleString(), color: { color: "#10b981", backgroundColor: "rgba(242, 253, 245, 0.9)" } },
//             ].map(({ icon, label, value, color }) => (
//               <div key={label} style={{ flex: "1 1 220px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
//                 <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", ...color }}>{icon}</span>
//                 <p style={{ fontSize: "11px", color: THEME.mutedForeground, fontWeight: "500", letterSpacing: "0.05em", margin: "0 0 2px 0" }}>{label.toUpperCase()}</p>
//                 <p style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{value}</p>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* ── Received Messages Interface Framework ── */}
//         <div style={{ display: "flex", flexDirection: "column", backgroundColor: THEME.card, borderRadius: "16px", border: `1px solid ${THEME.border}`, boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", overflow: "hidden" }}>

//           <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.borderLight}`, display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "rgba(248, 250, 252, 0.6)" }}>
//             <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               <div style={{ width: "36px", height: "36px", borderRadius: "8px", backgroundColor: THEME.primaryLight, display: "flex", alignItems: "center", justifyContent: "center", color: THEME.primary }}>
//                 <MailOpen size={18} />
//               </div>
//               <div>
//                 <h2 style={{ fontSize: "16px", fontWeight: "700", margin: 0, color: THEME.foreground }}>Received Messages</h2>
//                 <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>Manage live conversations and customer window conditions</p>
//               </div>
//             </div>
//           </div>

//           <div style={{ padding: "16px" }}>

//             {/* Search Bar Block */}
//             <div style={{ marginBottom: "16px", position: "relative", maxWidth: "420px", width: "100%" }}>
//               <Search style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, width: "16px", height: "16px" }} />
//               <input
//                 type="text"
//                 placeholder="Search by mobile number or text..."
//                 value={chatSearchQuery}
//                 onChange={(e) => {
//                   setChatSearchQuery(e.target.value);
//                   setChatCurrentPage(1);
//                 }}
//                 style={{ width: "100%", padding: "10px 16px 10px 40px", fontSize: "13px", borderRadius: "12px", border: `1px solid ${THEME.border}`, backgroundColor: THEME.background, outline: "none", color: THEME.foreground, boxSizing: "border-box" }}
//               />
//             </div>

//             {/* Main Contact Directory Log Layout */}
//             <div style={{ border: `1px solid ${THEME.border}`, borderRadius: "12px", overflow: "hidden" }}>
//               {paginatedChatMessages.length === 0 ? (
//                 <div style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground, fontSize: "13px" }}>
//                   No incoming log records matching parameters found.
//                 </div>
//               ) : (
//                 <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
//                   <thead>
//                     <tr style={{ backgroundColor: THEME.muted, borderBottom: `1px solid ${THEME.border}`, color: THEME.mutedForeground }}>
//                       <th style={{ padding: "12px" }}>Mobile Numbers</th>
//                       <th style={{ padding: "12px" }}>Received Message</th>
//                       <th style={{ padding: "12px" }}>Date & Time</th>
//                       <th style={{ padding: "12px", textAlign: "right" }}>Action Window</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {paginatedChatMessages.map((msg) => {
//                       const expired = checkIsExpired(msg.date);
//                       return (
//                         <tr
//                           key={msg.id}
//                           onClick={() => handleSelectChat(msg)}
//                           onMouseEnter={() => setHoveredRow(msg.id)}
//                           onMouseLeave={() => setHoveredRow(null)}
//                           style={{ cursor: "pointer", borderBottom: `1px solid ${THEME.borderLight}`, backgroundColor: hoveredRow === msg.id ? THEME.muted : "transparent" }}
//                         >
//                           <td style={{ padding: "12px", fontWeight: "600", fontFamily: "monospace" }}>{msg.mobile}</td>
//                           <td
//                             style={{
//                               padding: "12px",
//                               maxWidth: "300px",
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               color: THEME.mutedForeground
//                             }}
//                           >
//                             {msg.summaryMessage}
//                           </td>

//                           <td
//                             style={{
//                               padding: "12px",
//                               color: THEME.mutedForeground,
//                               fontSize: "12px",
//                               whiteSpace: "nowrap"
//                             }}
//                           >
//                             {parseSafeDate(msg.date).toLocaleString([], {
//                               day: "2-digit",
//                               month: "short",
//                               year: "numeric",
//                               hour: "2-digit",
//                               minute: "2-digit",
//                               hour12: true
//                             })}
//                           </td>

//                           <td style={{ padding: "12px", textAlign: "right" }}>
//                             <span style={{ padding: "2px 8px", borderRadius: "12px", fontSize: "10px", fontWeight: "bold", backgroundColor: expired ? THEME.dangerBg : THEME.successBg, color: expired ? THEME.dangerText : THEME.successText, border: `1px solid ${expired ? THEME.dangerBorder : THEME.successBorder}` }}>
//                               {expired ? "Expired" : "Active"}
//                             </span>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               )}
//             </div>

//             {/* Chat Pagination Controls */}
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "12px", fontSize: "12px", color: THEME.mutedForeground }}>
//               <span>Page {chatCurrentPage} of {chatTotalPages}</span>
//               <div style={{ display: "flex", gap: "6px" }}>
//                 <button disabled={chatCurrentPage === 1} onClick={() => setChatCurrentPage(p => Math.max(p - 1, 1))} style={{ padding: "4px 8px", borderRadius: "6px", border: `1px solid ${THEME.border}`, cursor: "pointer", opacity: chatCurrentPage === 1 ? 0.5 : 1 }}><ChevronLeft size={14} /></button>
//                 <button disabled={chatCurrentPage === chatTotalPages} onClick={() => setChatCurrentPage(p => Math.min(p + 1, chatTotalPages))} style={{ padding: "4px 8px", borderRadius: "6px", border: `1px solid ${THEME.border}`, cursor: "pointer", opacity: chatCurrentPage === chatTotalPages ? 0.5 : 1 }}><ChevronRight size={14} /></button>
//               </div>
//             </div>

//           </div>
//         </div>

//       </div>

//       {/* ── Virtualized Dialog Chat Panel Modal Box Backdrop ── */}
//       {isModalOpen && selectedChat && (
//         <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(15, 23, 42, 0.4)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "16px", boxSizing: "border-box" }}>

//           <div style={{ width: "100%", maxWidth: "600px", height: "80vh", backgroundColor: THEME.card, borderRadius: "16px", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.15)", display: "flex", flexDirection: "column", overflow: "hidden", border: `1px solid ${THEME.border}` }}>

//             {/* Modal Header */}
//             <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: THEME.background }}>
//               <div>
//                 <div style={{ fontWeight: "700", fontSize: "16px", fontFamily: "monospace", color: THEME.foreground }}>{selectedChat.mobile}</div>
//                 <div style={{ fontSize: "12px", color: THEME.mutedForeground }}>Interactive Feed Stream</div>
//               </div>
//               <button onClick={() => { setIsModalOpen(false); setSelectedChat(null); }} style={{ background: "none", border: "none", cursor: "pointer", color: THEME.mutedForeground, padding: "4px", borderRadius: "4px" }}><X size={20} /></button>
//             </div>

//             {/* Conversation Feed Bubbles Stream */}
//             <div style={{ flex: 1, padding: "20px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "14px", backgroundColor: "#f1f5f9" }}>
//               {conversationMessages.map((msg, i) => {
//                 const currentLabel = formatChatDate(msg.received_date);
//                 const displayDivider = currentLabel !== lastRenderedDateLabel;
//                 lastRenderedDateLabel = currentLabel;
//                 const isCustomer = msg.sender === "Customer";

//                 return (
//                   <div key={i} style={{ display: "flex", flexDirection: "column" }}>
//                     {displayDivider && (
//                       <div style={{ textAlign: "center", margin: "14px 0 8px 0", fontSize: "11px", color: THEME.mutedForeground, fontWeight: "600" }}>{currentLabel}</div>
//                     )}
//                     <div style={{ alignSelf: isCustomer ? "flex-start" : "flex-end", maxWidth: "85%", padding: "10px 14px", borderRadius: "12px", fontSize: "13px", lineHeight: "1.4", backgroundColor: isCustomer ? THEME.whatsappReceived : THEME.whatsappSent, border: `1px solid ${THEME.border}`, boxShadow: "0 1px 2px rgba(0,0,0,0.05)", color: THEME.foreground }}>
//                       <div>{msg.text}</div>
//                       <div style={{ fontSize: "9px", color: THEME.mutedForeground, textAlign: "right", marginTop: "4px" }}>{parseSafeDate(msg.received_date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
//                     </div>
//                   </div>
//                 );
//               })}
//               <div ref={chatEndRef} />
//             </div>

//             {/* Action Response Form Input footer */}
//             <form onSubmit={handleSendReply} style={{ padding: "16px", backgroundColor: THEME.card, borderTop: `1px solid ${THEME.border}`, display: "flex", gap: "10px" }}>
//               <input
//                 type="text"
//                 value={replyText}
//                 onChange={(e) => setReplyText(e.target.value)}
//                 placeholder={checkIsExpired(selectedChat.date) ? "Window limits exceeded 24h limits..." : "Type custom chat message response update..."}
//                 disabled={checkIsExpired(selectedChat.date)}
//                 style={{ flex: 1, padding: "12px", fontSize: "13px", borderRadius: "8px", border: `1px solid ${THEME.border}`, outline: "none", backgroundColor: checkIsExpired(selectedChat.date) ? THEME.muted : "transparent", color: THEME.foreground }}
//               />
//               <button type="submit" disabled={checkIsExpired(selectedChat.date) || !replyText.trim()} style={{ padding: "12px 20px", borderRadius: "8px", backgroundColor: THEME.primary, color: "#fff", border: "none", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", opacity: (!replyText.trim() || checkIsExpired(selectedChat.date)) ? 0.5 : 1 }}><Send size={14} /> Send</button>
//             </form>

//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default Dashboard;



















import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Send, MailOpen, Phone, BadgeCheck, Star, Activity, Search, X, ChevronLeft, ChevronRight } from 'lucide-react';

// --- Global Theme & Configuration Sync ---
const THEME = {
  background: "#f8fafc",
  foreground: "#0f172a",
  mutedForeground: "#64748b",
  card: "#ffffff",
  border: "#e2e8f0",
  borderLight: "#f1f5f9",
  primary: "#4f46e5",
  primaryLight: "#ede9fe",
  muted: "#f1f5f9",
  fail: "#ef4444",
  successBg: "#f0fdf4",
  successText: "#166534",
  successBorder: "#bbf7d0",
  dangerBg: "#fff1f2",
  dangerText: "#9f1239",
  dangerBorder: "#fecdd3",
  whatsappSent: "#d9fdd3",
  whatsappReceived: "#ffffff"
};

const ITEMS_PER_PAGE_CHAT = 6;

// --- Safe Parsers & Formatters ---
const parseSafeDate = (dateStr) => {
  if (!dateStr) return new Date();
  return new Date(dateStr.replace(" ", "T"));
};

const formatChatDate = (dateStr) => {
  const msgDate = parseSafeDate(dateStr);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (msgDate.toDateString() === today.toDateString()) {
    return "Today";
  } else if (msgDate.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  } else {
    return msgDate.toLocaleDateString(undefined, {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }
};

const checkIsExpired = (dateString) => {
  const msgDate = parseSafeDate(dateString).getTime();
  const currentDate = new Date().getTime();
  const hoursDifference = (currentDate - msgDate) / (1000 * 60 * 60);
  return hoursDifference > 24;
};

// Helper function to normalize phone numbers (removes '91' prefix and non-digit chars)
const normalizeMobile = (mobile) => {
  if (!mobile) return "";
  const cleaned = String(mobile).replace(/\D/g, "");
  if (cleaned.startsWith("91") && cleaned.length > 10) {
    return cleaned.slice(2);
  }
  return cleaned;
};

// --- Main Hybrid Dashboard Component ---
const Dashboard = () => {
  // --- Core States ---
  const [apiData, setApiData] = useState(null);
  const [contactsCount, setContactsCount] = useState(0);
  const [waId, setWaId] = useState(null);
  const [templateCount, setTemplateCount] = useState(0);
  const [webhookData, setWebhookData] = useState([]);
  const [contactsListMap, setContactsListMap] = useState({});
  const [isLogViewOnly, setIsLogViewOnly] = useState(false);

  // --- Received / Active Chats Subsystem States ---
  const [selectedChat, setSelectedChat] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [chatSearchQuery, setChatSearchQuery] = useState("");
  const [chatCurrentPage, setChatCurrentPage] = useState(1);
  const [conversationMessages, setConversationMessages] = useState([]);
  const [hoveredRow, setHoveredRow] = useState(null);

  const navigate = useNavigate();
  const loggedInUser = JSON.parse(sessionStorage.getItem('user'));
  const chatEndRef = useRef(null);

  // Auto Scroll Chat within modal context
  useEffect(() => {
    if (isModalOpen) {
      chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [conversationMessages, isModalOpen]);

  // --- Data Fetching Hook 1: User metadata ---
  useEffect(() => {
    const loggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loggedUser) return;

    const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
    if (!emailToUse) return;

    axios
      .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
      .then((response) => {
        const userData = response.data;
        if (userData.wa_id) {
          setWaId(userData.wa_id);

          fetch(`https://emedha.com/echatbot/enotifier/qratting.php?wid=${userData.wa_id}`)
            .then((res) => res.json())
            .then((data) => {
              if (data?.data?.length > 0) {
                const {
                  display_phone_number, verified_name, quality_rating, code_verification_status,
                } = data.data[0];

                setApiData({
                  phoneNumber: display_phone_number,
                  displayName: verified_name,
                  qualityRating: quality_rating,
                  codeverificationstatus: code_verification_status,
                });
              }
            });
        }
      })
      .catch((err) => {
        console.error("Error retrieving user data:", err);
      });
  }, []);

  // --- Hook 2: Contacts List & Count ---
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) return;

    const finalUserId = user.role === "admin" ? user.id : user.role === "member" ? user.userId : null;
    if (!finalUserId) return;

    axios
      .get(`https://botapi.emedha.in/pages/api/api/contacts/user?user_id=${finalUserId}`)
      .then((response) => {
        const contacts = response.data.contacts || [];
        setContactsCount(contacts.length);

        // Map normalized mobile numbers to contact names
        const map = {};
        contacts.forEach(c => {
          const normNum = normalizeMobile(c.mobile);
          if (normNum) {
            map[normNum] = c.name;
          }
        });
        setContactsListMap(map);
      })
      .catch((error) => {
        console.error("Failed to fetch contacts:", error);
      });
  }, []);

  // --- Hook 3: Template Status Counts ---
  useEffect(() => {
    if (!waId) return;
    fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?wid=${waId}`)
      .then(res => res.text())
      .then(text => {
        const jsonStart = text.indexOf('{');
        const jsonString = text.substring(jsonStart);
        const data = JSON.parse(jsonString);
        if (Array.isArray(data?.data)) {
          setTemplateCount(data.data.length);
        }
      })
      .catch(err => {
        console.error("Failed to fetch template data:", err);
      });
  }, [waId]);

  // --- Hook 4: Webhook log processor table fetch ---
  useEffect(() => {
    const webhookTable = loggedInUser?.webhook_table;
    if (!webhookTable) return;
    axios.post('https://botapi.emedha.in/pages/api/api/webhook-dataprkrv', {
      webhook_table: webhookTable
    })
      .then((response) => {
        const sortedData = response.data.sort((a, b) =>
          new Date(b.received_date) - new Date(a.received_date)
        );
        setWebhookData(sortedData);
      })
      .catch((err) => {
        console.error('Error fetching data:', err);
      });
  }, []);

  const conversationData = webhookData
    .filter(item => {
      if (
        item.status === "sent" ||
        item.status === "delivered" ||
        item.status === "read"
      ) {
        return false;
      }

      return (
        (item.receivedMessage && item.receivedMessage.trim() !== "") ||
        (item.sentMessage && item.sentMessage.trim() !== "")
      );
    })
    .map(item => {
      const rawMobile = item.customer_mobile || item.waid || "";
      const normMobile = normalizeMobile(rawMobile);
      const contactName = contactsListMap[normMobile] || null;

      return {
        id: item.id,
        mobile: normMobile || "Unknown Number",
        rawMobile: rawMobile,
        name: contactName,
        sender: item.sentMessage ? "You" : "Customer",
        messageText: item.sentMessage || item.receivedMessage,
        date: item.received_date
      };
    });

  const messagesSentCount = webhookData.filter(
    item => item.status === "sent" || item.status === "session_sent"
  ).length;

  // --- Interactive Search Filters Mechanism ---
  const filteredChatMessages = conversationData.filter((msg) => {
    const query = chatSearchQuery.toLowerCase();
    return (
      (msg.mobile || "").toLowerCase().includes(query) ||
      (msg.name || "").toLowerCase().includes(query) ||
      (msg.messageText || "").toLowerCase().includes(query)
    );
  });

  const uniqueContactsMap = {};
  filteredChatMessages.forEach(msg => {
    const mobile = msg.mobile;
    if (!mobile) return;

    if (!uniqueContactsMap[mobile]) {
      uniqueContactsMap[mobile] = { ...msg, summaryMessage: msg.messageText };
    } else {
      if (parseSafeDate(msg.date) > parseSafeDate(uniqueContactsMap[mobile].date)) {
        const currentValidText = msg.messageText || uniqueContactsMap[mobile].summaryMessage;
        uniqueContactsMap[mobile] = {
          ...msg,
          summaryMessage: currentValidText
        };
      } else if (!uniqueContactsMap[mobile].summaryMessage && msg.messageText) {
        uniqueContactsMap[mobile].summaryMessage = msg.messageText;
      }
    }
  });

  const contactsList = Object.values(uniqueContactsMap).sort((a, b) => parseSafeDate(b.date) - parseSafeDate(a.date));
  const chatTotalPages = Math.ceil(contactsList.length / ITEMS_PER_PAGE_CHAT) || 1;
  const chatStartIndex = (chatCurrentPage - 1) * ITEMS_PER_PAGE_CHAT;
  const paginatedChatMessages = contactsList.slice(chatStartIndex, chatStartIndex + ITEMS_PER_PAGE_CHAT);

  const handleSelectChat = (msg) => {
    setSelectedChat(msg);
    setReplyText("");

    const conversation = conversationData
      .filter(item => item.mobile === msg.mobile)
      .sort((a, b) => parseSafeDate(a.date) - parseSafeDate(b.date))
      .map(item => ({
        sender: item.sender,
        text: item.messageText,
        received_date: item.date
      }));

    setConversationMessages(conversation);
    setIsModalOpen(true);
  };

  const handleSendReply = async (e) => {
    e.preventDefault();
    if (!replyText.trim()) return;

    const user = JSON.parse(sessionStorage.getItem("user"));
    const payload = {
      id: user?.wa_id || "",
      mobile: `91${selectedChat.mobile}`, // Ensure sending API receives with 91 prefix if needed
      message: replyText,
    };

    try {
      await axios.post("https://emedha.com/echatbot/enotifier/client-message.php", payload);
      setConversationMessages((prev) => [
        ...prev,
        {
          sender: "You",
          text: replyText,
          received_date: new Date().toISOString(),
        },
      ]);
      setReplyText("");
    } catch (err) {
      console.error(err);
    }
  };

  let lastRenderedDateLabel = null;

  return (
    <div style={{ flex: 1, height: "100vh", backgroundColor: THEME.background, fontFamily: "system-ui, -apple-system, sans-serif", boxSizing: "border-box" }}>

      {/* Header section */}
      <div style={{ paddingBottom: "20px" }}>
        <h1 style={{ fontSize: "22px", fontWeight: "bold", color: THEME.foreground, margin: 0 }}>Dashboard</h1>
        <p style={{ fontSize: "14px", color: THEME.mutedForeground, marginTop: "2px", marginBottom: 0 }}>Overview of your chatbot activity</p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>

        {!isLogViewOnly && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
            {[
              { icon: <Phone size={15} />, label: "Phone Number", value: apiData?.phoneNumber || '—', color: { color: "#4f46e5", backgroundColor: "#e0e7ff" } },
              { icon: <BadgeCheck size={15} />, label: "Display Name", value: apiData?.displayName || '—', color: { color: "#0284c7", backgroundColor: "#e0f2fe" } },
              {
                icon: <Star size={15} />,
                label: "Quality Rating",
                value: (
                  <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                    <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: apiData?.qualityRating === 'GREEN' ? "#10b981" : "#f59e0b" }} />
                    {apiData?.qualityRating === 'GREEN' ? 'High' : apiData?.qualityRating ? 'Low' : '—'}
                  </span>
                ),
                color: apiData?.qualityRating === 'GREEN' ? { color: "#059669", backgroundColor: "#ecfdf5" } : { color: "#d97706", backgroundColor: "#fef3c7" }
              },
              { icon: <Activity size={15} />, label: "MESSAGES SENT", value: messagesSentCount.toLocaleString(), color: { color: "#10b981", backgroundColor: "rgba(242, 253, 245, 0.9)" } },
            ].map(({ icon, label, value, color }) => (
              <div key={label} style={{ flex: "1 1 220px", backgroundColor: THEME.card, borderRadius: "12px", border: `1px solid ${THEME.border}`, padding: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                <span style={{ width: "28px", height: "28px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: "12px", ...color }}>{icon}</span>
                <p style={{ fontSize: "11px", color: THEME.mutedForeground, fontWeight: "500", letterSpacing: "0.05em", margin: "0 0 2px 0" }}>{label.toUpperCase()}</p>
                <p style={{ fontSize: "14px", fontWeight: "600", color: THEME.foreground, margin: 0 }}>{value}</p>
              </div>
            ))}
          </div>
        )}

        {/* ── Received Messages Interface Framework ── */}
        <div style={{ display: "flex", flexDirection: "column", backgroundColor: THEME.card, borderRadius: "16px", border: `1px solid ${THEME.border}`, boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)", overflow: "hidden" }}>

          <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.borderLight}`, display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "rgba(248, 250, 252, 0.6)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "36px", height: "36px", borderRadius: "8px", backgroundColor: THEME.primaryLight, display: "flex", alignItems: "center", justifyContent: "center", color: THEME.primary }}>
                <MailOpen size={18} />
              </div>
              <div>
                <h2 style={{ fontSize: "16px", fontWeight: "700", margin: 0, color: THEME.foreground }}>Received Messages</h2>
                <p style={{ fontSize: "12px", color: THEME.mutedForeground, margin: 0 }}>Manage live conversations and customer window conditions</p>
              </div>
            </div>
          </div>

          <div style={{ padding: "16px" }}>

            {/* Search Bar Block */}
            <div style={{ marginBottom: "16px", position: "relative", maxWidth: "420px", width: "100%" }}>
              <Search style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", color: THEME.mutedForeground, width: "16px", height: "16px" }} />
              <input
                type="text"
                placeholder="Search by name, mobile number or text..."
                value={chatSearchQuery}
                onChange={(e) => {
                  setChatSearchQuery(e.target.value);
                  setChatCurrentPage(1);
                }}
                style={{ width: "100%", padding: "10px 16px 10px 40px", fontSize: "13px", borderRadius: "12px", border: `1px solid ${THEME.border}`, backgroundColor: THEME.background, outline: "none", color: THEME.foreground, boxSizing: "border-box" }}
              />
            </div>

            {/* Main Contact Directory Log Layout */}
            <div style={{ border: `1px solid ${THEME.border}`, borderRadius: "12px", overflow: "hidden" }}>
              {paginatedChatMessages.length === 0 ? (
                <div style={{ padding: "32px", textAlign: "center", color: THEME.mutedForeground, fontSize: "13px" }}>
                  No incoming log records matching parameters found.
                </div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" }}>
                  <thead>
                    <tr style={{ backgroundColor: THEME.muted, borderBottom: `1px solid ${THEME.border}`, color: THEME.mutedForeground }}>
                      <th style={{ padding: "12px" }}>Contact Name & Number</th>
                      <th style={{ padding: "12px" }}>Received Message</th>
                      <th style={{ padding: "12px" }}>Date & Time</th>
                      <th style={{ padding: "12px", textAlign: "right" }}>Action Window</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedChatMessages.map((msg) => {
                      const expired = checkIsExpired(msg.date);
                      return (
                        <tr
                          key={msg.id}
                          onClick={() => handleSelectChat(msg)}
                          onMouseEnter={() => setHoveredRow(msg.id)}
                          onMouseLeave={() => setHoveredRow(null)}
                          style={{ cursor: "pointer", borderBottom: `1px solid ${THEME.borderLight}`, backgroundColor: hoveredRow === msg.id ? THEME.muted : "transparent" }}
                        >
                          <td style={{ padding: "12px" }}>
                            <div style={{ fontWeight: "600", color: THEME.foreground }}>
                              {msg.name || "Unknown Name"}
                            </div>
                            <div style={{ fontSize: "11px", color: THEME.mutedForeground, fontFamily: "monospace" }}>
                              {msg.mobile}
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              maxWidth: "300px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: THEME.mutedForeground
                            }}
                          >
                            {msg.summaryMessage}
                          </td>

                          <td
                            style={{
                              padding: "12px",
                              color: THEME.mutedForeground,
                              fontSize: "12px",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {parseSafeDate(msg.date).toLocaleString([], {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true
                            })}
                          </td>

                          <td style={{ padding: "12px", textAlign: "right" }}>
                            <span style={{ padding: "2px 8px", borderRadius: "12px", fontSize: "10px", fontWeight: "bold", backgroundColor: expired ? THEME.dangerBg : THEME.successBg, color: expired ? THEME.dangerText : THEME.successText, border: `1px solid ${expired ? THEME.dangerBorder : THEME.successBorder}` }}>
                              {expired ? "Expired" : "Active"}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>

            {/* Chat Pagination Controls */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "12px", fontSize: "12px", color: THEME.mutedForeground }}>
              <span>Page {chatCurrentPage} of {chatTotalPages}</span>
              <div style={{ display: "flex", gap: "6px" }}>
                <button disabled={chatCurrentPage === 1} onClick={() => setChatCurrentPage(p => Math.max(p - 1, 1))} style={{ padding: "4px 8px", borderRadius: "6px", border: `1px solid ${THEME.border}`, cursor: "pointer", opacity: chatCurrentPage === 1 ? 0.5 : 1 }}><ChevronLeft size={14} /></button>
                <button disabled={chatCurrentPage === chatTotalPages} onClick={() => setChatCurrentPage(p => Math.min(p + 1, chatTotalPages))} style={{ padding: "4px 8px", borderRadius: "6px", border: `1px solid ${THEME.border}`, cursor: "pointer", opacity: chatCurrentPage === chatTotalPages ? 0.5 : 1 }}><ChevronRight size={14} /></button>
              </div>
            </div>

          </div>
        </div>

      </div>

      {/* ── Virtualized Dialog Chat Panel Modal Box Backdrop ── */}
      {isModalOpen && selectedChat && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(15, 23, 42, 0.4)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "16px", boxSizing: "border-box" }}>

          <div style={{ width: "100%", maxWidth: "600px", height: "80vh", backgroundColor: THEME.card, borderRadius: "16px", boxShadow: "0 20px 25px -5px rgba(0,0,0,0.15)", display: "flex", flexDirection: "column", overflow: "hidden", border: `1px solid ${THEME.border}` }}>

            {/* Modal Header */}
            <div style={{ padding: "16px 20px", borderBottom: `1px solid ${THEME.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: THEME.background }}>
              <div>
                <div style={{ fontWeight: "700", fontSize: "16px", color: THEME.foreground }}>{selectedChat.name || "Unknown Name"}</div>
                <div style={{ fontSize: "12px", fontFamily: "monospace", color: THEME.mutedForeground }}>{selectedChat.mobile}</div>
              </div>
              <button onClick={() => { setIsModalOpen(false); setSelectedChat(null); }} style={{ background: "none", border: "none", cursor: "pointer", color: THEME.mutedForeground, padding: "4px", borderRadius: "4px" }}><X size={20} /></button>
            </div>

            {/* Conversation Feed Bubbles Stream */}
            <div style={{ flex: 1, padding: "20px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "14px", backgroundColor: "#f1f5f9" }}>
              {conversationMessages.map((msg, i) => {
                const currentLabel = formatChatDate(msg.received_date);
                const displayDivider = currentLabel !== lastRenderedDateLabel;
                lastRenderedDateLabel = currentLabel;
                const isCustomer = msg.sender === "Customer";

                return (
                  <div key={i} style={{ display: "flex", flexDirection: "column" }}>
                    {displayDivider && (
                      <div style={{ textAlign: "center", margin: "14px 0 8px 0", fontSize: "11px", color: THEME.mutedForeground, fontWeight: "600" }}>{currentLabel}</div>
                    )}
                    <div style={{ alignSelf: isCustomer ? "flex-start" : "flex-end", maxWidth: "85%", padding: "10px 14px", borderRadius: "12px", fontSize: "13px", lineHeight: "1.4", backgroundColor: isCustomer ? THEME.whatsappReceived : THEME.whatsappSent, border: `1px solid ${THEME.border}`, boxShadow: "0 1px 2px rgba(0,0,0,0.05)", color: THEME.foreground }}>
                      <div>{msg.text}</div>
                      <div style={{ fontSize: "9px", color: THEME.mutedForeground, textAlign: "right", marginTop: "4px" }}>{parseSafeDate(msg.received_date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
                    </div>
                  </div>
                );
              })}
              <div ref={chatEndRef} />
            </div>

            {/* Action Response Form Input footer */}
            <form onSubmit={handleSendReply} style={{ padding: "16px", backgroundColor: THEME.card, borderTop: `1px solid ${THEME.border}`, display: "flex", gap: "10px" }}>
              <input
                type="text"
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                placeholder={checkIsExpired(selectedChat.date) ? "Window limits exceeded 24h limits..." : "Type custom chat message response update..."}
                disabled={checkIsExpired(selectedChat.date)}
                style={{ flex: 1, padding: "12px", fontSize: "13px", borderRadius: "8px", border: `1px solid ${THEME.border}`, outline: "none", backgroundColor: checkIsExpired(selectedChat.date) ? THEME.muted : "transparent", color: THEME.foreground }}
              />
              <button type="submit" disabled={checkIsExpired(selectedChat.date) || !replyText.trim()} style={{ padding: "12px 20px", borderRadius: "8px", backgroundColor: THEME.primary, color: "#fff", border: "none", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", opacity: (!replyText.trim() || checkIsExpired(selectedChat.date)) ? 0.5 : 1 }}><Send size={14} /> Send</button>
            </form>

          </div>
        </div>
      )}

    </div>
  );
};

export default Dashboard;